import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _61a2fa64 = () => interopDefault(import('../pages/about/index.vue' /* webpackChunkName: "pages/about/index" */))
const _644a2bb8 = () => interopDefault(import('../pages/api-and-developers.vue' /* webpackChunkName: "pages/api-and-developers" */))
const _e8d02a1c = () => interopDefault(import('../pages/articles/index.vue' /* webpackChunkName: "pages/articles/index" */))
const _31c9adac = () => interopDefault(import('../pages/community/index.vue' /* webpackChunkName: "pages/community/index" */))
const _4d46ae1e = () => interopDefault(import('../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _7279e414 = () => interopDefault(import('../pages/contests/index.vue' /* webpackChunkName: "pages/contests/index" */))
const _80f83206 = () => interopDefault(import('../pages/delete-account.vue' /* webpackChunkName: "pages/delete-account" */))
const _004bc310 = () => interopDefault(import('../pages/glossary.vue' /* webpackChunkName: "pages/glossary" */))
const _18d2af58 = () => interopDefault(import('../pages/go-fly-a-kite.vue' /* webpackChunkName: "pages/go-fly-a-kite" */))
const _0b7663ee = () => interopDefault(import('../pages/grades.vue' /* webpackChunkName: "pages/grades" */))
const _0bffb104 = () => interopDefault(import('../pages/gym-administrations/index.vue' /* webpackChunkName: "pages/gym-administrations/index" */))
const _880cafd8 = () => interopDefault(import('../pages/home/index.vue' /* webpackChunkName: "pages/home/index" */))
const _5eb43a08 = () => interopDefault(import('../pages/indoor/index.vue' /* webpackChunkName: "pages/indoor/index" */))
const _267fe939 = () => interopDefault(import('../pages/library.vue' /* webpackChunkName: "pages/library" */))
const _ecccaede = () => interopDefault(import('../pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _b6960184 = () => interopDefault(import('../pages/merci.vue' /* webpackChunkName: "pages/merci" */))
const _d4f2a2be = () => interopDefault(import('../pages/new/index.vue' /* webpackChunkName: "pages/new/index" */))
const _8fcce1cc = () => interopDefault(import('../pages/new-password.vue' /* webpackChunkName: "pages/new-password" */))
const _33b27869 = () => interopDefault(import('../pages/notifications/index.vue' /* webpackChunkName: "pages/notifications/index" */))
const _7ddbbfc9 = () => interopDefault(import('../pages/oblyk.vue' /* webpackChunkName: "pages/oblyk" */))
const _5f9c4a06 = () => interopDefault(import('../pages/outdoor/index.vue' /* webpackChunkName: "pages/outdoor/index" */))
const _b71a8cf4 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _ee253f10 = () => interopDefault(import('../pages/report-problem.vue' /* webpackChunkName: "pages/report-problem" */))
const _11c4214b = () => interopDefault(import('../pages/reset-password.vue' /* webpackChunkName: "pages/reset-password" */))
const _a050ca9a = () => interopDefault(import('../pages/sign-in.vue' /* webpackChunkName: "pages/sign-in" */))
const _77241dae = () => interopDefault(import('../pages/sign-up.vue' /* webpackChunkName: "pages/sign-up" */))
const _ae181278 = () => interopDefault(import('../pages/success-account-deleting.vue' /* webpackChunkName: "pages/success-account-deleting" */))
const _0bd0a664 = () => interopDefault(import('../pages/support-us.vue' /* webpackChunkName: "pages/support-us" */))
const _1be21387 = () => interopDefault(import('../pages/about/indoor.vue' /* webpackChunkName: "pages/about/indoor" */))
const _054f1681 = () => interopDefault(import('../pages/about/partner-search.vue' /* webpackChunkName: "pages/about/partner-search" */))
const _665aca95 = () => interopDefault(import('../pages/areas/new.vue' /* webpackChunkName: "pages/areas/new" */))
const _395dd6c0 = () => interopDefault(import('../pages/articles/new.vue' /* webpackChunkName: "pages/articles/new" */))
const _6967d930 = () => interopDefault(import('../pages/ascents/new.vue' /* webpackChunkName: "pages/ascents/new" */))
const _afee5500 = () => interopDefault(import('../pages/community/search.vue' /* webpackChunkName: "pages/community/search" */))
const _acf29966 = () => interopDefault(import('../pages/crags/new.vue' /* webpackChunkName: "pages/crags/new" */))
const _9383edea = () => interopDefault(import('../pages/crags/search.vue' /* webpackChunkName: "pages/crags/search" */))
const _5031cafe = () => interopDefault(import('../pages/en/cookie-and-audience-measurement.vue' /* webpackChunkName: "pages/en/cookie-and-audience-measurement" */))
const _5771dcbb = () => interopDefault(import('../pages/en/terms-of-use.vue' /* webpackChunkName: "pages/en/terms-of-use" */))
const _6a45da21 = () => interopDefault(import('../pages/errors/debug.vue' /* webpackChunkName: "pages/errors/debug" */))
const _64b760d2 = () => interopDefault(import('../pages/errors/right-required.vue' /* webpackChunkName: "pages/errors/right-required" */))
const _5a0129bc = () => interopDefault(import('../pages/errors/session-expired.vue' /* webpackChunkName: "pages/errors/session-expired" */))
const _235d3d2a = () => interopDefault(import('../pages/escalade-en/france/index.vue' /* webpackChunkName: "pages/escalade-en/france/index" */))
const _307abfb6 = () => interopDefault(import('../pages/find/climbers.vue' /* webpackChunkName: "pages/find/climbers" */))
const _5e5383da = () => interopDefault(import('../pages/find/crags.vue' /* webpackChunkName: "pages/find/crags" */))
const _0b132db5 = () => interopDefault(import('../pages/find/guide-books.vue' /* webpackChunkName: "pages/find/guide-books" */))
const _e60e03a8 = () => interopDefault(import('../pages/find/gyms.vue' /* webpackChunkName: "pages/find/gyms" */))
const _84be8928 = () => interopDefault(import('../pages/fr/conditions-d-utilisation.vue' /* webpackChunkName: "pages/fr/conditions-d-utilisation" */))
const _23e1e2c7 = () => interopDefault(import('../pages/fr/cookie-et-mesure-d-audience.vue' /* webpackChunkName: "pages/fr/cookie-et-mesure-d-audience" */))
const _708898c0 = () => interopDefault(import('../pages/guide-book-papers/find.vue' /* webpackChunkName: "pages/guide-book-papers/find" */))
const _a10d72ee = () => interopDefault(import('../pages/guide-book-papers/new.vue' /* webpackChunkName: "pages/guide-book-papers/new" */))
const _e84648e2 = () => interopDefault(import('../pages/guide-book-papers/new-versions.vue' /* webpackChunkName: "pages/guide-book-papers/new-versions" */))
const _0f0ac4c4 = () => interopDefault(import('../pages/guide-book-papers/recommended.vue' /* webpackChunkName: "pages/guide-book-papers/recommended" */))
const _13a8ec65 = () => interopDefault(import('../pages/guide-books/features.vue' /* webpackChunkName: "pages/guide-books/features" */))
const _ae2846ca = () => interopDefault(import('../pages/gyms/new.vue' /* webpackChunkName: "pages/gyms/new" */))
const _22e50aec = () => interopDefault(import('../pages/gyms/starter.vue' /* webpackChunkName: "pages/gyms/starter" */))
const _5a029f62 = () => interopDefault(import('../pages/home/climbing-sessions/index.vue' /* webpackChunkName: "pages/home/climbing-sessions/index" */))
const _323d66ab = () => interopDefault(import('../pages/home/community.vue' /* webpackChunkName: "pages/home/community" */))
const _05da80b1 = () => interopDefault(import('../pages/home/community/followers.vue' /* webpackChunkName: "pages/home/community/followers" */))
const _6e3cb67d = () => interopDefault(import('../pages/home/community/subscribes.vue' /* webpackChunkName: "pages/home/community/subscribes" */))
const _1e70ba19 = () => interopDefault(import('../pages/home/favorites.vue' /* webpackChunkName: "pages/home/favorites" */))
const _cbbfa570 = () => interopDefault(import('../pages/home/favorites/crags.vue' /* webpackChunkName: "pages/home/favorites/crags" */))
const _5d5a6efe = () => interopDefault(import('../pages/home/favorites/gyms.vue' /* webpackChunkName: "pages/home/favorites/gyms" */))
const _e25351c4 = () => interopDefault(import('../pages/home/guide-books/index.vue' /* webpackChunkName: "pages/home/guide-books/index" */))
const _6bb01626 = () => interopDefault(import('../pages/home/media.vue' /* webpackChunkName: "pages/home/media" */))
const _1b83f68c = () => interopDefault(import('../pages/home/media/photos.vue' /* webpackChunkName: "pages/home/media/photos" */))
const _9fde97de = () => interopDefault(import('../pages/home/media/videos.vue' /* webpackChunkName: "pages/home/media/videos" */))
const _b51d6656 = () => interopDefault(import('../pages/home/messenger.vue' /* webpackChunkName: "pages/home/messenger" */))
const _661afce6 = () => interopDefault(import('../pages/home/messenger/new.vue' /* webpackChunkName: "pages/home/messenger/new" */))
const _42368726 = () => interopDefault(import('../pages/home/messenger/_conversationId/index.vue' /* webpackChunkName: "pages/home/messenger/_conversationId/index" */))
const _42bc75d8 = () => interopDefault(import('../pages/home/search-climbers.vue' /* webpackChunkName: "pages/home/search-climbers" */))
const _38b34d14 = () => interopDefault(import('../pages/home/settings/index.vue' /* webpackChunkName: "pages/home/settings/index" */))
const _2391e062 = () => interopDefault(import('../pages/indoor/search.vue' /* webpackChunkName: "pages/indoor/search" */))
const _00e32ff2 = () => interopDefault(import('../pages/maps/climbers.vue' /* webpackChunkName: "pages/maps/climbers" */))
const _3fd4d190 = () => interopDefault(import('../pages/maps/crags.vue' /* webpackChunkName: "pages/maps/crags" */))
const _28b64e74 = () => interopDefault(import('../pages/maps/guide-book-papers.vue' /* webpackChunkName: "pages/maps/guide-book-papers" */))
const _4f18070e = () => interopDefault(import('../pages/maps/gyms.vue' /* webpackChunkName: "pages/maps/gyms" */))
const _7865ac9e = () => interopDefault(import('../pages/maps/my-map.vue' /* webpackChunkName: "pages/maps/my-map" */))
const _09086953 = () => interopDefault(import('../pages/newsletters/subscribe.vue' /* webpackChunkName: "pages/newsletters/subscribe" */))
const _235ddc44 = () => interopDefault(import('../pages/newsletters/successful-subscribe.vue' /* webpackChunkName: "pages/newsletters/successful-subscribe" */))
const _cb991636 = () => interopDefault(import('../pages/newsletters/successful-unsubscribe.vue' /* webpackChunkName: "pages/newsletters/successful-unsubscribe" */))
const _371a79cc = () => interopDefault(import('../pages/newsletters/unsubscribe.vue' /* webpackChunkName: "pages/newsletters/unsubscribe" */))
const _102942af = () => interopDefault(import('../pages/organizations/new.vue' /* webpackChunkName: "pages/organizations/new" */))
const _3b01d0b8 = () => interopDefault(import('../pages/words/new.vue' /* webpackChunkName: "pages/words/new" */))
const _5fc6df4c = () => interopDefault(import('../pages/ascents/indoor/new.vue' /* webpackChunkName: "pages/ascents/indoor/new" */))
const _d2803f56 = () => interopDefault(import('../pages/ascents/outdoor/new.vue' /* webpackChunkName: "pages/ascents/outdoor/new" */))
const _68ea605a = () => interopDefault(import('../pages/embed/crags/map.vue' /* webpackChunkName: "pages/embed/crags/map" */))
const _1b8439a4 = () => interopDefault(import('../pages/embed/guide-books/map.vue' /* webpackChunkName: "pages/embed/guide-books/map" */))
const _0191633a = () => interopDefault(import('../pages/home/ascents/indoor/index.vue' /* webpackChunkName: "pages/home/ascents/indoor/index" */))
const _2069d0f0 = () => interopDefault(import('../pages/home/ascents/outdoor.vue' /* webpackChunkName: "pages/home/ascents/outdoor" */))
const _ee0c4fea = () => interopDefault(import('../pages/home/ascents/outdoor/index.vue' /* webpackChunkName: "pages/home/ascents/outdoor/index" */))
const _0015dd37 = () => interopDefault(import('../pages/home/ascents/outdoor/analytiks.vue' /* webpackChunkName: "pages/home/ascents/outdoor/analytiks" */))
const _32df58d1 = () => interopDefault(import('../pages/home/ascents/outdoor/projects.vue' /* webpackChunkName: "pages/home/ascents/outdoor/projects" */))
const _e59cd8f2 = () => interopDefault(import('../pages/home/ascents/outdoor/tick-list.vue' /* webpackChunkName: "pages/home/ascents/outdoor/tick-list" */))
const _06207726 = () => interopDefault(import('../pages/home/guide-books/add.vue' /* webpackChunkName: "pages/home/guide-books/add" */))
const _89e03bf4 = () => interopDefault(import('../pages/home/publications/new.vue' /* webpackChunkName: "pages/home/publications/new" */))
const _c45493d8 = () => interopDefault(import('../pages/home/settings/applications/index.vue' /* webpackChunkName: "pages/home/settings/applications/index" */))
const _c8736bf2 = () => interopDefault(import('../pages/home/settings/avatar.vue' /* webpackChunkName: "pages/home/settings/avatar" */))
const _764fe65a = () => interopDefault(import('../pages/home/settings/banner.vue' /* webpackChunkName: "pages/home/settings/banner" */))
const _5020820c = () => interopDefault(import('../pages/home/settings/connection.vue' /* webpackChunkName: "pages/home/settings/connection" */))
const _0751a0ac = () => interopDefault(import('../pages/home/settings/general.vue' /* webpackChunkName: "pages/home/settings/general" */))
const _75d6742a = () => interopDefault(import('../pages/home/settings/notifications.vue' /* webpackChunkName: "pages/home/settings/notifications" */))
const _ac0651de = () => interopDefault(import('../pages/home/settings/others.vue' /* webpackChunkName: "pages/home/settings/others" */))
const _020e138a = () => interopDefault(import('../pages/home/settings/partner.vue' /* webpackChunkName: "pages/home/settings/partner" */))
const _2190fa4a = () => interopDefault(import('../pages/home/settings/privacy.vue' /* webpackChunkName: "pages/home/settings/privacy" */))
const _0184c0c0 = () => interopDefault(import('../pages/outdoor/search/crag-routes.vue' /* webpackChunkName: "pages/outdoor/search/crag-routes" */))
const _43620a3c = () => interopDefault(import('../pages/outdoor/search/crags.vue' /* webpackChunkName: "pages/outdoor/search/crags" */))
const _30c7e297 = () => interopDefault(import('../pages/outdoor/search/guide-books.vue' /* webpackChunkName: "pages/outdoor/search/guide-books" */))
const _1cebb1d2 = () => interopDefault(import('../pages/home/settings/applications/new/my-compet.vue' /* webpackChunkName: "pages/home/settings/applications/new/my-compet" */))
const _1a33ab50 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _4c5fcd0a = () => interopDefault(import('../pages/embed/publications/_publicationId/index.vue' /* webpackChunkName: "pages/embed/publications/_publicationId/index" */))
const _1b763c88 = () => interopDefault(import('../pages/home/climbing-sessions/_sessionDate/index.vue' /* webpackChunkName: "pages/home/climbing-sessions/_sessionDate/index" */))
const _1f6af937 = () => interopDefault(import('../pages/home/publications/_publicationId/edit.vue' /* webpackChunkName: "pages/home/publications/_publicationId/edit" */))
const _01cabf0a = () => interopDefault(import('../pages/escalade-en/france/_departmentNumber/_departementName/index.vue' /* webpackChunkName: "pages/escalade-en/france/_departmentNumber/_departementName/index" */))
const _127d4849 = () => interopDefault(import('../pages/climbers/_userName.vue' /* webpackChunkName: "pages/climbers/_userName" */))
const _6adab40c = () => interopDefault(import('../pages/climbers/_userName/index.vue' /* webpackChunkName: "pages/climbers/_userName/index" */))
const _0f2dbe13 = () => interopDefault(import('../pages/climbers/_userName/ascents.vue' /* webpackChunkName: "pages/climbers/_userName/ascents" */))
const _343b5cff = () => interopDefault(import('../pages/climbers/_userName/ascents/indoor.vue' /* webpackChunkName: "pages/climbers/_userName/ascents/indoor" */))
const _4aa78d80 = () => interopDefault(import('../pages/climbers/_userName/ascents/outdoor.vue' /* webpackChunkName: "pages/climbers/_userName/ascents/outdoor" */))
const _6cc91662 = () => interopDefault(import('../pages/climbers/_userName/followers.vue' /* webpackChunkName: "pages/climbers/_userName/followers" */))
const _1a91221e = () => interopDefault(import('../pages/climbers/_userName/media.vue' /* webpackChunkName: "pages/climbers/_userName/media" */))
const _434e11c2 = () => interopDefault(import('../pages/climbers/_userName/media/photos.vue' /* webpackChunkName: "pages/climbers/_userName/media/photos" */))
const _0120c119 = () => interopDefault(import('../pages/climbers/_userName/media/videos.vue' /* webpackChunkName: "pages/climbers/_userName/media/videos" */))
const _32f5cefd = () => interopDefault(import('../pages/climbers/_userName/publications.vue' /* webpackChunkName: "pages/climbers/_userName/publications" */))
const _229a461f = () => interopDefault(import('../pages/climbers/_userName/subscribes.vue' /* webpackChunkName: "pages/climbers/_userName/subscribes" */))
const _7357d252 = () => interopDefault(import('../pages/comments/_commentId/index.vue' /* webpackChunkName: "pages/comments/_commentId/index" */))
const _713403ce = () => interopDefault(import('../pages/escalade-autour-de/_townName/index.vue' /* webpackChunkName: "pages/escalade-autour-de/_townName/index" */))
const _b689c524 = () => interopDefault(import('../pages/gr/_gymAndRouteId/index.vue' /* webpackChunkName: "pages/gr/_gymAndRouteId/index" */))
const _8f5b999a = () => interopDefault(import('../pages/grs/_gymId/index.vue' /* webpackChunkName: "pages/grs/_gymId/index" */))
const _dd5b20b2 = () => interopDefault(import('../pages/gym-chains/_gymChainId.vue' /* webpackChunkName: "pages/gym-chains/_gymChainId" */))
const _35805cea = () => interopDefault(import('../pages/gym-chains/_gymChainId/index.vue' /* webpackChunkName: "pages/gym-chains/_gymChainId/index" */))
const _a2e28706 = () => interopDefault(import('../pages/photos/_photoId/index.vue' /* webpackChunkName: "pages/photos/_photoId/index" */))
const _5d660e9e = () => interopDefault(import('../pages/publications/_publicationId/index.vue' /* webpackChunkName: "pages/publications/_publicationId/index" */))
const _5edb450f = () => interopDefault(import('../pages/videos/_videoId/index.vue' /* webpackChunkName: "pages/videos/_videoId/index" */))
const _f6274b4a = () => interopDefault(import('../pages/alerts/_alertId/edit.vue' /* webpackChunkName: "pages/alerts/_alertId/edit" */))
const _533e55c4 = () => interopDefault(import('../pages/authors/_authorId/cover.vue' /* webpackChunkName: "pages/authors/_authorId/cover" */))
const _7d3353e6 = () => interopDefault(import('../pages/authors/_authorId/edit.vue' /* webpackChunkName: "pages/authors/_authorId/edit" */))
const _bda354d6 = () => interopDefault(import('../pages/comments/_commentId/edit.vue' /* webpackChunkName: "pages/comments/_commentId/edit" */))
const _40fae55f = () => interopDefault(import('../pages/guide-book-pdfs/_guideBookPdfId/edit.vue' /* webpackChunkName: "pages/guide-book-pdfs/_guideBookPdfId/edit" */))
const _6a83dd9f = () => interopDefault(import('../pages/guide-book-webs/_guideBookWebId/edit.vue' /* webpackChunkName: "pages/guide-book-webs/_guideBookWebId/edit" */))
const _0074b3ed = () => interopDefault(import('../pages/links/_linkId/edit.vue' /* webpackChunkName: "pages/links/_linkId/edit" */))
const _00f40464 = () => interopDefault(import('../pages/areas/_areaId/_areaName.vue' /* webpackChunkName: "pages/areas/_areaId/_areaName" */))
const _5ec6a032 = () => interopDefault(import('../pages/areas/_areaId/_areaName/index.vue' /* webpackChunkName: "pages/areas/_areaId/_areaName/index" */))
const _5af75353 = () => interopDefault(import('../pages/areas/_areaId/_areaName/crags.vue' /* webpackChunkName: "pages/areas/_areaId/_areaName/crags" */))
const _08499688 = () => interopDefault(import('../pages/areas/_areaId/_areaName/photos.vue' /* webpackChunkName: "pages/areas/_areaId/_areaName/photos" */))
const _72bdd382 = () => interopDefault(import('../pages/articles/_articleId/_articleName/index.vue' /* webpackChunkName: "pages/articles/_articleId/_articleName/index" */))
const _0ff1e653 = () => interopDefault(import('../pages/crag-routes/_cragRouteId/_cragRouteName/index.vue' /* webpackChunkName: "pages/crag-routes/_cragRouteId/_cragRouteName/index" */))
const _74e49ffa = () => interopDefault(import('../pages/crag-sectors/_cragSectorId/_cragSectorName.vue' /* webpackChunkName: "pages/crag-sectors/_cragSectorId/_cragSectorName" */))
const _b9ee2f74 = () => interopDefault(import('../pages/crag-sectors/_cragSectorId/_cragSectorName/index.vue' /* webpackChunkName: "pages/crag-sectors/_cragSectorId/_cragSectorName/index" */))
const _2da6b75a = () => interopDefault(import('../pages/crag-sectors/_cragSectorId/_cragSectorName/maps.vue' /* webpackChunkName: "pages/crag-sectors/_cragSectorId/_cragSectorName/maps" */))
const _76f6083d = () => interopDefault(import('../pages/crag-sectors/_cragSectorId/_cragSectorName/photos.vue' /* webpackChunkName: "pages/crag-sectors/_cragSectorId/_cragSectorName/photos" */))
const _b8a478a8 = () => interopDefault(import('../pages/crags/_cragId/_cragName.vue' /* webpackChunkName: "pages/crags/_cragId/_cragName" */))
const _6b8bd92f = () => interopDefault(import('../pages/crags/_cragId/_cragName/index.vue' /* webpackChunkName: "pages/crags/_cragId/_cragName/index" */))
const _181ed1b6 = () => interopDefault(import('../pages/crags/_cragId/_cragName/guide-books.vue' /* webpackChunkName: "pages/crags/_cragId/_cragName/guide-books" */))
const _3be83496 = () => interopDefault(import('../pages/crags/_cragId/_cragName/links.vue' /* webpackChunkName: "pages/crags/_cragId/_cragName/links" */))
const _61ff994d = () => interopDefault(import('../pages/crags/_cragId/_cragName/maps/index.vue' /* webpackChunkName: "pages/crags/_cragId/_cragName/maps/index" */))
const _825d9718 = () => interopDefault(import('../pages/crags/_cragId/_cragName/photos.vue' /* webpackChunkName: "pages/crags/_cragId/_cragName/photos" */))
const _5c9def7d = () => interopDefault(import('../pages/crags/_cragId/_cragName/publications/index.vue' /* webpackChunkName: "pages/crags/_cragId/_cragName/publications/index" */))
const _b6c10900 = () => interopDefault(import('../pages/crags/_cragId/_cragName/routes/index.vue' /* webpackChunkName: "pages/crags/_cragId/_cragName/routes/index" */))
const _66bcfbea = () => interopDefault(import('../pages/crags/_cragId/_cragName/publications/new.vue' /* webpackChunkName: "pages/crags/_cragId/_cragName/publications/new" */))
const _a5e42188 = () => interopDefault(import('../pages/crags/_cragId/_cragName/publications/_publicationId/edit.vue' /* webpackChunkName: "pages/crags/_cragId/_cragName/publications/_publicationId/edit" */))
const _002f10cc = () => interopDefault(import('../pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName.vue' /* webpackChunkName: "pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName" */))
const _7fe6ce4f = () => interopDefault(import('../pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/index.vue' /* webpackChunkName: "pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/index" */))
const _9eac130e = () => interopDefault(import('../pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/alternatives.vue' /* webpackChunkName: "pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/alternatives" */))
const _0a4171bb = () => interopDefault(import('../pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/crags.vue' /* webpackChunkName: "pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/crags" */))
const _504329b6 = () => interopDefault(import('../pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/links.vue' /* webpackChunkName: "pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/links" */))
const _b088a9ce = () => interopDefault(import('../pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/map.vue' /* webpackChunkName: "pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/map" */))
const _35d4e354 = () => interopDefault(import('../pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/photos.vue' /* webpackChunkName: "pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/photos" */))
const _4a3d2666 = () => interopDefault(import('../pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/points-of-sale.vue' /* webpackChunkName: "pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/points-of-sale" */))
const _28324e5d = () => interopDefault(import('../pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/publications/index.vue' /* webpackChunkName: "pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/publications/index" */))
const _558018eb = () => interopDefault(import('../pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/publications/new.vue' /* webpackChunkName: "pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/publications/new" */))
const _52ba73c8 = () => interopDefault(import('../pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/publications/_publicationId/edit.vue' /* webpackChunkName: "pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/publications/_publicationId/edit" */))
const _15ddd70c = () => interopDefault(import('../pages/gyms/_gymId/_gymName.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName" */))
const _6a76d77d = () => interopDefault(import('../pages/gyms/_gymId/_gymName/index.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/index" */))
const _e2b31080 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/followers.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/followers" */))
const _49931fef = () => interopDefault(import('../pages/gyms/_gymId/_gymName/publications/index.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/publications/index" */))
const _09273021 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/ranking.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/ranking" */))
const _8a06fad6 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/spaces/index.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/spaces/index" */))
const _5ca7b206 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/publications/new.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/publications/new" */))
const _70e4702e = () => interopDefault(import('../pages/gyms/_gymId/_gymName/publications/_publicationId/edit.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/publications/_publicationId/edit" */))
const _6e7bd871 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/spaces/_gymSpaceId/_gymSpaceName/index.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/spaces/_gymSpaceId/_gymSpaceName/index" */))
const _3a10644a = () => interopDefault(import('../pages/organizations/_organizationId/_organizationName.vue' /* webpackChunkName: "pages/organizations/_organizationId/_organizationName" */))
const _88e1e966 = () => interopDefault(import('../pages/organizations/_organizationId/_organizationName/index.vue' /* webpackChunkName: "pages/organizations/_organizationId/_organizationName/index" */))
const _f886c236 = () => interopDefault(import('../pages/words/_wordId/_slugName/index.vue' /* webpackChunkName: "pages/words/_wordId/_slugName/index" */))
const _7161830a = () => interopDefault(import('../pages/alerts/_alertableType/_alertableId/new.vue' /* webpackChunkName: "pages/alerts/_alertableType/_alertableId/new" */))
const _3ff2f0c2 = () => interopDefault(import('../pages/articles/_articleId/_articleName/add-crags.vue' /* webpackChunkName: "pages/articles/_articleId/_articleName/add-crags" */))
const _0b174c9d = () => interopDefault(import('../pages/articles/_articleId/_articleName/add-guide-books.vue' /* webpackChunkName: "pages/articles/_articleId/_articleName/add-guide-books" */))
const _18e003e7 = () => interopDefault(import('../pages/articles/_articleId/_articleName/cover.vue' /* webpackChunkName: "pages/articles/_articleId/_articleName/cover" */))
const _0194d78a = () => interopDefault(import('../pages/articles/_articleId/_articleName/edit.vue' /* webpackChunkName: "pages/articles/_articleId/_articleName/edit" */))
const _c442f6fe = () => interopDefault(import('../pages/articles/_articleId/_articleName/photos.vue' /* webpackChunkName: "pages/articles/_articleId/_articleName/photos" */))
const _b1bb6f90 = () => interopDefault(import('../pages/comments/_commentableType/_commentableId/new.vue' /* webpackChunkName: "pages/comments/_commentableType/_commentableId/new" */))
const _76ed0e1e = () => interopDefault(import('../pages/contests/_gymId/_contestId/print-results.vue' /* webpackChunkName: "pages/contests/_gymId/_contestId/print-results" */))
const _7c8d9165 = () => interopDefault(import('../pages/links/_linkableType/_linkableId/new.vue' /* webpackChunkName: "pages/links/_linkableType/_linkableId/new" */))
const _6669f905 = () => interopDefault(import('../pages/photos/_illustrableType/_illustrableId/new.vue' /* webpackChunkName: "pages/photos/_illustrableType/_illustrableId/new" */))
const _c5d7dc42 = () => interopDefault(import('../pages/reports/_reportableType/_reportableId/new.vue' /* webpackChunkName: "pages/reports/_reportableType/_reportableId/new" */))
const _1b6db03c = () => interopDefault(import('../pages/versions/_versionType/_versionId/changes.vue' /* webpackChunkName: "pages/versions/_versionType/_versionId/changes" */))
const _da1ea664 = () => interopDefault(import('../pages/videos/_viewableType/_viewableId/new.vue' /* webpackChunkName: "pages/videos/_viewableType/_viewableId/new" */))
const _33ad93c7 = () => interopDefault(import('../pages/words/_wordId/_slugName/edit.vue' /* webpackChunkName: "pages/words/_wordId/_slugName/edit" */))
const _660f62bb = () => interopDefault(import('../pages/contests/_gymId/_contestId/_contestJudgeUuid/index.vue' /* webpackChunkName: "pages/contests/_gymId/_contestId/_contestJudgeUuid/index" */))
const _4ebcd770 = () => interopDefault(import('../pages/photos/_illustrableType/_illustrableId/_photoId/edit.vue' /* webpackChunkName: "pages/photos/_illustrableType/_illustrableId/_photoId/edit" */))
const _5d3c93e0 = () => interopDefault(import('../pages/videos/_viewableType/_viewableId/_videoId/edit.vue' /* webpackChunkName: "pages/videos/_viewableType/_viewableId/_videoId/edit" */))
const _1324d144 = () => interopDefault(import('../pages/gym-chains/_gymChainId/banner.vue' /* webpackChunkName: "pages/gym-chains/_gymChainId/banner" */))
const _31278122 = () => interopDefault(import('../pages/gym-chains/_gymChainId/edit.vue' /* webpackChunkName: "pages/gym-chains/_gymChainId/edit" */))
const _4a842043 = () => interopDefault(import('../pages/gym-chains/_gymChainId/logo.vue' /* webpackChunkName: "pages/gym-chains/_gymChainId/logo" */))
const _4f624dfc = () => interopDefault(import('../pages/areas/_areaId/_areaName/add-crag.vue' /* webpackChunkName: "pages/areas/_areaId/_areaName/add-crag" */))
const _2de65a85 = () => interopDefault(import('../pages/areas/_areaId/_areaName/edit.vue' /* webpackChunkName: "pages/areas/_areaId/_areaName/edit" */))
const _8fd0f6a8 = () => interopDefault(import('../pages/crags/_cragId/_cragName/add-on-area.vue' /* webpackChunkName: "pages/crags/_cragId/_cragName/add-on-area" */))
const _d996390e = () => interopDefault(import('../pages/crags/_cragId/_cragName/add-on-guide-book.vue' /* webpackChunkName: "pages/crags/_cragId/_cragName/add-on-guide-book" */))
const _816e2f86 = () => interopDefault(import('../pages/crags/_cragId/_cragName/edit.vue' /* webpackChunkName: "pages/crags/_cragId/_cragName/edit" */))
const _489d0195 = () => interopDefault(import('../pages/crags/_cragId/_cragName/new-pdf-guide-book.vue' /* webpackChunkName: "pages/crags/_cragId/_cragName/new-pdf-guide-book" */))
const _72fc96f3 = () => interopDefault(import('../pages/crags/_cragId/_cragName/new-web-guide-book.vue' /* webpackChunkName: "pages/crags/_cragId/_cragName/new-web-guide-book" */))
const _b115f74c = () => interopDefault(import('../pages/crags/_cragId/_cragName/approaches/new.vue' /* webpackChunkName: "pages/crags/_cragId/_cragName/approaches/new" */))
const _e524a742 = () => interopDefault(import('../pages/crags/_cragId/_cragName/maps/edit.vue' /* webpackChunkName: "pages/crags/_cragId/_cragName/maps/edit" */))
const _6377d637 = () => interopDefault(import('../pages/crags/_cragId/_cragName/parks/new.vue' /* webpackChunkName: "pages/crags/_cragId/_cragName/parks/new" */))
const _648c32ce = () => interopDefault(import('../pages/crags/_cragId/_cragName/routes/new.vue' /* webpackChunkName: "pages/crags/_cragId/_cragName/routes/new" */))
const _5ea310fb = () => interopDefault(import('../pages/crags/_cragId/_cragName/sectors/new.vue' /* webpackChunkName: "pages/crags/_cragId/_cragName/sectors/new" */))
const _0e4a81ad = () => interopDefault(import('../pages/crags/_cragId/_cragName/approaches/_approachId/edit.vue' /* webpackChunkName: "pages/crags/_cragId/_cragName/approaches/_approachId/edit" */))
const _7dbb5324 = () => interopDefault(import('../pages/crags/_cragId/_cragName/parks/_parkId/edit.vue' /* webpackChunkName: "pages/crags/_cragId/_cragName/parks/_parkId/edit" */))
const _387578bc = () => interopDefault(import('../pages/crags/_cragId/_cragName/routes/_cragRouteId/_cragRouteName/edit.vue' /* webpackChunkName: "pages/crags/_cragId/_cragName/routes/_cragRouteId/_cragRouteName/edit" */))
const _42ddf143 = () => interopDefault(import('../pages/crags/_cragId/_cragName/sectors/_cragSectorId/_cragSectorName/edit.vue' /* webpackChunkName: "pages/crags/_cragId/_cragName/sectors/_cragSectorId/_cragSectorName/edit" */))
const _d23a5eb0 = () => interopDefault(import('../pages/crags/_cragId/_cragName/routes/_cragRouteId/_cragRouteName/ascents/new.vue' /* webpackChunkName: "pages/crags/_cragId/_cragName/routes/_cragRouteId/_cragRouteName/ascents/new" */))
const _79dbdf54 = () => interopDefault(import('../pages/crags/_cragId/_cragName/sectors/_cragSectorId/_cragSectorName/routes/new.vue' /* webpackChunkName: "pages/crags/_cragId/_cragName/sectors/_cragSectorId/_cragSectorName/routes/new" */))
const _36d259ea = () => interopDefault(import('../pages/crags/_cragId/_cragName/routes/_cragRouteId/_cragRouteName/ascents/_ascentCragRouteId/edit.vue' /* webpackChunkName: "pages/crags/_cragId/_cragName/routes/_cragRouteId/_cragRouteName/ascents/_ascentCragRouteId/edit" */))
const _1caa92d8 = () => interopDefault(import('../pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/add-crag.vue' /* webpackChunkName: "pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/add-crag" */))
const _2608feb4 = () => interopDefault(import('../pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/cover.vue' /* webpackChunkName: "pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/cover" */))
const _b1aa61c6 = () => interopDefault(import('../pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/edit.vue' /* webpackChunkName: "pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/edit" */))
const _108b4d00 = () => interopDefault(import('../pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/place-of-sales/new.vue' /* webpackChunkName: "pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/place-of-sales/new" */))
const _0bfa4bd0 = () => interopDefault(import('../pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/place-of-sales/_placeOfSaleId/edit.vue' /* webpackChunkName: "pages/guide-book-papers/_guideBookPaperId/_guideBookPaperName/place-of-sales/_placeOfSaleId/edit" */))
const _25156e05 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/administration-request.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/administration-request" */))
const _56b3c104 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/administrator-required.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/administrator-required" */))
const _1b2858ac = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/index.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/index" */))
const _7cfda911 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/banner.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/banner" */))
const _92042fa2 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/edit.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/edit" */))
const _5f4af160 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/logo.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/logo" */))
const _0451bc9a = () => interopDefault(import('../pages/gyms/_gymId/_gymName/select-space.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/select-space" */))
const _01c6dc5f = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/administrators/index.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/administrators/index" */))
const _5e50734b = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/championships/index.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/championships/index" */))
const _7475087f = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/climbing-styles/index.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/climbing-styles/index" */))
const _9e88cfe6 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/comments/index.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/comments/index" */))
const _a0470390 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/contests/index.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/contests/index" */))
const _15a2bcfe = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/first-difficulty-system.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/first-difficulty-system" */))
const _c9c472fa = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/first-space.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/first-space" */))
const _3e3e6fd6 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/indoor-subscriptions/index.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/indoor-subscriptions/index" */))
const _f4b15606 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/label-templates/index.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/label-templates/index" */))
const _2dc79948 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/levels/index.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/levels/index" */))
const _b2dbc18e = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/openers/index.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/openers/index" */))
const _100e5e62 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/opening-sheets/index.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/opening-sheets/index" */))
const _71270aac = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/ranking-systems/index.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/ranking-systems/index" */))
const _73d319c9 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/tree-structures.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/tree-structures" */))
const _cb36a01e = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/videos/index.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/videos/index" */))
const _6f39fb23 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/spaces/new.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/spaces/new" */))
const _c0f78126 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/administrators/new.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/administrators/new" */))
const _0dc2bd4e = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/championships/new.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/championships/new" */))
const _cbcaf8f4 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/contests/new.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/contests/new" */))
const _2bc6478b = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/label-templates/new.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/label-templates/new" */))
const _201670c7 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/openers/new.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/openers/new" */))
const _ba8b33a0 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/opening-sheets/new.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/opening-sheets/new" */))
const _20ba5ecf = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/routes/cross-statistics.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/routes/cross-statistics" */))
const _2bb82ae2 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/routes/statistics.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/routes/statistics" */))
const _18deb2a4 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/routes/tables.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/routes/tables" */))
const _060a0b22 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/space-groups/new.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/space-groups/new" */))
const _1f2c992e = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/spaces/edit-three-d.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/spaces/edit-three-d" */))
const _032910fc = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/three-d-assets/new.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/three-d-assets/new" */))
const _3bd82a10 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/championships/_championshipId.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/championships/_championshipId" */))
const _e65b510a = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/championships/_championshipId/index.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/championships/_championshipId/index" */))
const _7183385f = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/championships/_championshipId/results.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/championships/_championshipId/results" */))
const _2d07635a = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/contests/_contestId.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/contests/_contestId" */))
const _7d230346 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/contests/_contestId/index.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/contests/_contestId/index" */))
const _04fade31 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/contests/_contestId/banner.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/contests/_contestId/banner" */))
const _bdf43562 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/contests/_contestId/edit.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/contests/_contestId/edit" */))
const _88d4697e = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/contests/_contestId/judges.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/contests/_contestId/judges" */))
const _3dfc9236 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/contests/_contestId/participants.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/contests/_contestId/participants" */))
const _209da27e = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/contests/_contestId/results.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/contests/_contestId/results" */))
const _016d83b0 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/contests/_contestId/statistics.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/contests/_contestId/statistics" */))
const _2fbb657e = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/contests/_contestId/teams.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/contests/_contestId/teams" */))
const _bd7d0c02 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/contests/_contestId/time-line.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/contests/_contestId/time-line" */))
const _6553d2ca = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/label-templates/_gymLabelTemplateId/index.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/label-templates/_gymLabelTemplateId/index" */))
const _14c6b121 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/opening-sheets/_gymOpeningSheetId/index.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/opening-sheets/_gymOpeningSheetId/index" */))
const _38728210 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/administrators/_gymAdministratorId/edit.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/administrators/_gymAdministratorId/edit" */))
const _db478a14 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/label-templates/_gymLabelTemplateId/print.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/label-templates/_gymLabelTemplateId/print" */))
const _f923fc5c = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/openers/_gymOpenerId/edit.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/openers/_gymOpenerId/edit" */))
const _4c665508 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/opening-sheets/_gymOpeningSheetId/print.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/opening-sheets/_gymOpeningSheetId/print" */))
const _bf441fea = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/space-groups/_gymSpaceGroupId/edit.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/space-groups/_gymSpaceGroupId/edit" */))
const _18b43fd8 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/spaces/_gymSpaceId/edit-three-d.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/spaces/_gymSpaceId/edit-three-d" */))
const _31c26586 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/spaces/_gymSpaceId/take-three-d-picture.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/spaces/_gymSpaceId/take-three-d-picture" */))
const _4a5f9c16 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/admins/three-d-assets/_threeDAssetId/edit.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/admins/three-d-assets/_threeDAssetId/edit" */))
const _45616942 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/contests/rankers/_contestId/_contestName/index.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/contests/rankers/_contestId/_contestName/index" */))
const _4695fcac = () => interopDefault(import('../pages/gyms/_gymId/_gymName/championships/_championshipId/_championshipName/index.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/championships/_championshipId/_championshipName/index" */))
const _51d42dd4 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/contests/_contestId/_contestName.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/contests/_contestId/_contestName" */))
const _0497f552 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/contests/_contestId/_contestName/index.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/contests/_contestId/_contestName/index" */))
const _005f243e = () => interopDefault(import('../pages/gyms/_gymId/_gymName/contests/_contestId/_contestName/my-contest.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/contests/_contestId/_contestName/my-contest" */))
const _30b0df3b = () => interopDefault(import('../pages/gyms/_gymId/_gymName/contests/_contestId/_contestName/results.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/contests/_contestId/_contestName/results" */))
const _b2ca0e8a = () => interopDefault(import('../pages/gyms/_gymId/_gymName/spaces/_gymSpaceId/_gymSpaceName/edit.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/spaces/_gymSpaceId/_gymSpaceName/edit" */))
const _0eee2776 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/spaces/_gymSpaceId/_gymSpaceName/select-sector.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/spaces/_gymSpaceId/_gymSpaceName/select-sector" */))
const _23af2c7c = () => interopDefault(import('../pages/gyms/_gymId/_gymName/spaces/_gymSpaceId/_gymSpaceName/upload-3d.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/spaces/_gymSpaceId/_gymSpaceName/upload-3d" */))
const _9a340758 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/spaces/_gymSpaceId/_gymSpaceName/upload-plan.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/spaces/_gymSpaceId/_gymSpaceName/upload-plan" */))
const _2ab316bd = () => interopDefault(import('../pages/gyms/_gymId/_gymName/spaces/_gymSpaceId/_gymSpaceName/sectors/new.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/spaces/_gymSpaceId/_gymSpaceName/sectors/new" */))
const _3fa10915 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/spaces/_gymSpaceId/_gymSpaceName/routes/_gymRouteId/edit.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/spaces/_gymSpaceId/_gymSpaceName/routes/_gymRouteId/edit" */))
const _2ad2eb7a = () => interopDefault(import('../pages/gyms/_gymId/_gymName/spaces/_gymSpaceId/_gymSpaceName/routes/_gymRouteId/picture.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/spaces/_gymSpaceId/_gymSpaceName/routes/_gymRouteId/picture" */))
const _0b591ff1 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/spaces/_gymSpaceId/_gymSpaceName/routes/_gymRouteId/thumbnail.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/spaces/_gymSpaceId/_gymSpaceName/routes/_gymRouteId/thumbnail" */))
const _256a8735 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/spaces/_gymSpaceId/_gymSpaceName/sectors/_gymSectorId/add-to-publication.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/spaces/_gymSpaceId/_gymSpaceName/sectors/_gymSectorId/add-to-publication" */))
const _0b5b16f9 = () => interopDefault(import('../pages/gyms/_gymId/_gymName/spaces/_gymSpaceId/_gymSpaceName/sectors/_gymSectorId/edit.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/spaces/_gymSpaceId/_gymSpaceName/sectors/_gymSectorId/edit" */))
const _12d7648a = () => interopDefault(import('../pages/gyms/_gymId/_gymName/spaces/_gymSpaceId/_gymSpaceName/sectors/_gymSectorId/routes/new.vue' /* webpackChunkName: "pages/gyms/_gymId/_gymName/spaces/_gymSpaceId/_gymSpaceName/sectors/_gymSectorId/routes/new" */))
const _29b00b42 = () => interopDefault(import('../pages/organizations/_organizationId/_organizationName/edit.vue' /* webpackChunkName: "pages/organizations/_organizationId/_organizationName/edit" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _61a2fa64,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"À propos d'Oblyk","metaDescription":"En savoir plus sur Oblyk, pourquoi et qui est derrière le projet"},"en":{"metaTitle":"About Oblyk","metaDescription":"Learn more about Oblyk, why and who is behind the project"}}}},
    name: "about"
  }, {
    path: "/api-and-developers",
    component: _644a2bb8,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"API des falaises et voies d'escalades","metaDescription":"Les API d'Oblyk vous permettes de consulter une grande base de donnée des falaises et voies d'escalade en France et dans le monde"},"en":{"metaTitle":"Climbing crags and routes API","metaDescription":"Oblyk's APIs allow you to consult a large database of crags and climbing routes in France and in the world"}}}},
    name: "api-and-developers"
  }, {
    path: "/articles",
    component: _e8d02a1c,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Les actualités d'Oblyk","metaDescription":"Voir toutes les actualités d'Oblyk, la communauté de grimpeur"},"en":{"metaTitle":"Oblyk news","metaDescription":"View all Oblyk news, the climbing community"}}}},
    name: "articles"
  }, {
    path: "/community",
    component: _31c9adac,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Communauté","metaDescription":"La communauté d'Oblyk, les grimpeurs et grimpeuses et recherche de partenaire"},"en":{"metaTitle":"Community","metaDescription":"The Oblyk community, climbers and partner search"}}}},
    name: "community"
  }, {
    path: "/contact",
    component: _4d46ae1e,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Contacter l'équipe d'Oblyk","metaDescription":"Pour toute question, toute proposition, ou tout simplement pour nous aider, n'hésitez pas à nous contacter !"},"en":{"metaTitle":"Contact the Oblyk team","metaDescription":"For any question, any proposal, or simply to help us, do not hesitate to contact us!"}}},"test":true},
    name: "contact"
  }, {
    path: "/contests",
    component: _7279e414,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Les contests","metaDescription":"Trouver et participer à un contest organiser par une salles d'escalade"},"en":{"metaTitle":"Opens","metaDescription":"Find and take part in a competition organised by a climbing gym"}}}},
    name: "contests"
  }, {
    path: "/delete-account",
    component: _80f83206,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Supprimer mon compte","metaDescription":"Supprimez votre compte et toutes les données qui s'y rapportent"},"en":{"metaTitle":"Delete my account","metaDescription":"Delete your account and all related data"}}},"test":true},
    name: "delete-account"
  }, {
    path: "/glossary",
    component: _004bc310,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Lexique des terms d'escalade","metaDescription":"Le lexique communautaire des termes de l'escalade pour décoder le parler grimpeur·euse"},"en":{"metaTitle":"Glossary of climbing terms","metaDescription":"The community lexicon of climbing terms to decode the climber's language"}}}},
    name: "glossary"
  }, {
    path: "/go-fly-a-kite",
    component: _18d2af58,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Vous êtes un robot ?","metaDescription":"Vous avez un comportement anormal, nous vous avons bloqué."},"en":{"metaTitle":"You are robot?","metaDescription":"You have an abnormal behavior, we blocked you"}}}},
    name: "go-fly-a-kite"
  }, {
    path: "/grades",
    component: _0b7663ee,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Les cotations sur Oblyk","metaDescription":"Oblyk permet plusieurs notations pour la cotations et un code couleur est associé à une difficulté, voici comment ça marche"},"en":{"metaTitle":"Grades on oblyk","metaDescription":"Oblyk allows several notations for scoring and a color code is associated with a difficulty, here is how it works"}}}},
    name: "grades"
  }, {
    path: "/gym-administrations",
    component: _0bffb104,
    meta: {"middleware":["auth","admin"]},
    name: "gym-administrations"
  }, {
    path: "/home",
    component: _880cafd8,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Mon profil Oblyk"},"en":{"metaTitle":"My Oblyk profile"}}}},
    name: "home"
  }, {
    path: "/indoor",
    component: _5eb43a08,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Indoor","metaDescription":"Tous l'indoor sur oblyk, vos favoris, cartes de salles, salles proches"},"en":{"metaTitle":"Indoor","metaDescription":"All indoor activities on oblyk, your favourites, venue maps, nearby venues"}}}},
    name: "indoor"
  }, {
    path: "/library",
    component: _267fe939,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Topos d'escalade","metaDescription":"Les topos de France et du monde : infos, falaises, carte des sites"},"en":{"metaTitle":"Climbing guides","metaDescription":"Guides of France and the world: information, cliffs, map of sites"}}}},
    name: "library"
  }, {
    path: "/maintenance",
    component: _ecccaede,
    meta: {"layout":"blank"},
    name: "maintenance"
  }, {
    path: "/merci",
    component: _b6960184,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Merci !","metaDescription":"Un énorme merci pour votre don ! Grâce à vous, Oblyk peut continuer à se développer et envisager l'avenir plus sereinement."},"en":{"metaTitle":"Thanks !","metaDescription":"A huge thank you for your donation! Thanks to you, Oblyk can continue to develop and look forward to a brighter future."}}}},
    name: "merci"
  }, {
    path: "/new",
    component: _d4f2a2be,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Enrichir Oblyk"},"en":{"metaTitle":"Enrich Oblyk"}}}},
    name: "new"
  }, {
    path: "/new-password",
    component: _8fcce1cc,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Changer mon mot de passe"},"en":{"metaTitle":"Change my password"}}}},
    name: "new-password"
  }, {
    path: "/notifications",
    component: _33b27869,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Mes notifications"},"en":{"metaTitle":"My notifications"}}}},
    name: "notifications"
  }, {
    path: "/oblyk",
    component: _7ddbbfc9,
    meta: {"name":"OblykView","i18n":{"messages":{"fr":{"metaTitle":"Oblyk - Escalade, Carnet de croix & Carte des grimpeur·euse·s","metaDescription":"Oblyk est un site communautaire d'escalade outdoor et indoor, on peut : voir les informations des falaises, noter ses croix, trouver un partenaire d'escalade, etc."},"en":{"metaTitle":"Oblyk - Climbing community, Log book & Partner search","metaDescription":"Oblyk is an outdoor and indoor climbing community site, you can: see crag information, keep a logbook, find a climbing partner, etc."}}}},
    name: "oblyk"
  }, {
    path: "/outdoor",
    component: _5f9c4a06,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Outdoor","metaDescription":"Tous l'outdoor sur oblyk, vos favoris, cartes de falaises, falaises proches"},"en":{"metaTitle":"Outdoor","metaDescription":"All outdoor activities on oblyk, your favourites, crags maps, nearby cliffs"}}}},
    name: "outdoor"
  }, {
    path: "/privacy",
    component: _b71a8cf4,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Ma confidentialité"},"en":{"metaTitle":"My privacy"}}}},
    name: "privacy"
  }, {
    path: "/report-problem",
    component: _ee253f10,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Signaler un problème","metaDescription":"Vous avez trouvé un problème? dit le nous pour qu'on le corrige"},"en":{"metaTitle":"Report a problem","metaDescription":"Have you found a problem? Tell us so we can fix it"}}}},
    name: "report-problem"
  }, {
    path: "/reset-password",
    component: _11c4214b,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Mot de passe oublié ?","metaDescription":"Vous avez oublié votre mot de passe ? renseignez votre adresse mail pour le réinitialiser"},"en":{"metaTitle":"Forgot your password?","metaDescription":"Forgot your password? Enter your email address to reset it"}}}},
    name: "reset-password"
  }, {
    path: "/sign-in",
    component: _a050ca9a,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Me connecter","metaDescription":"Me connecter à mon compte Oblyk et retrouver toutes les infos de la grimpes autour de chez moi"},"en":{"metaTitle":"Connect me","metaDescription":"Connect me to my Oblyk account and find all informations about the climbing around me"}}}},
    name: "sign-in"
  }, {
    path: "/sign-up",
    component: _77241dae,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Me créer un compte","metaDescription":"Me créer un mon compte pour suivre ma progression, trouver des partenaire d'escalade et avoir des infos local de la communauté de la grimpe"},"en":{"metaTitle":"Create an account","metaDescription":"Create an account to track my progress, find climbing partners and get local info from the climbing community"}}}},
    name: "sign-up"
  }, {
    path: "/success-account-deleting",
    component: _ae181278,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Compte supprimé"},"en":{"metaTitle":"Account deleted"}}}},
    name: "success-account-deleting"
  }, {
    path: "/support-us",
    component: _0bd0a664,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Supporter Oblyk, faire un don","metaDescription":"Supporter le développement d'Oblyk pour qu'il puisse continuer à évoluer"},"en":{"metaTitle":"Support Oblyk, make a donation","metaDescription":"Support the development of Oblyk so that it can continue to evolve"}}}},
    name: "support-us"
  }, {
    path: "/about/indoor",
    component: _1be21387,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Créer le topo indoor de votre salle d'escalade","metaDescription":"Organisez votre salle d'escalade en espace et secteur, permettez à vos grimpeurs et grimpeuses de noter leur croix, supervisez vos ouvertures, et pleins d'autres fonctionnalités"},"en":{"metaTitle":"Create the indoor guidebook of your climbing gym","metaDescription":"Organize your climbing gym in space and sector, allow your climbers to rate their ascents, supervise your openings, and many other features"}}}},
    name: "about-indoor"
  }, {
    path: "/about/partner-search",
    component: _054f1681,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Recherche de partenaire d'escalade, comment ça marche ?","metaDescription":"La recherche de partenaire d'escalade te permet de trouver des grimpeur·euse·s autours de toi qui cherche aussi des gens pour grimper. Comment ça fonctionne ?"},"en":{"metaTitle":"Search for a climbing partner, how does it work?","metaDescription":"The climbing partner search allows you to find climbers around you who are also looking for people to climb with. How does it work?"}}}},
    name: "about-partner-search"
  }, {
    path: "/areas/new",
    component: _665aca95,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Créer un groupe de site"},"en":{"metaTitle":"Create crags group"}}},"orphanRoute":true},
    name: "areas-new"
  }, {
    path: "/articles/new",
    component: _395dd6c0,
    meta: {"middleware":["auth"],"orphanRoute":true},
    name: "articles-new"
  }, {
    path: "/ascents/new",
    component: _6967d930,
    meta: {},
    name: "ascents-new"
  }, {
    path: "/community/search",
    component: _afee5500,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Chercher un grimpeur, une grimpeuse","metaDescription":"Retrouver vos amis ou des gens avec qui aller grimper"},"en":{"metaTitle":"Looking for a climber","metaDescription":"Find friends or people to go climbing with"}}}},
    name: "community-search"
  }, {
    path: "/crags/new",
    component: _acf29966,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Ajouter une falaise"},"en":{"metaTitle":"Create new crag"}}},"orphanRoute":true},
    name: "crags-new"
  }, {
    path: "/crags/search",
    component: _9383edea,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Recherche avancée de sites d'escalades : trouver des sites d'escalades en France et dans le monde","metaDescription":"Trouver exactement le site d'escalade que vous chercher, filter avec le niveau du site, l'orientation, le temps de marche, etc."},"en":{"metaTitle":"Advanced climbing crag search : find climbing crags in France and in the world","metaDescription":"Find exactly the climbing crag you are looking for, filter with the level of the crag, the orientation, the walking time, etc."}}}},
    name: "crags-search"
  }, {
    path: "/en/cookie-and-audience-measurement",
    component: _5031cafe,
    meta: {},
    name: "en-cookie-and-audience-measurement"
  }, {
    path: "/en/terms-of-use",
    component: _5771dcbb,
    meta: {},
    name: "en-terms-of-use"
  }, {
    path: "/errors/debug",
    component: _6a45da21,
    meta: {"layout":"blank"},
    name: "errors-debug"
  }, {
    path: "/errors/right-required",
    component: _64b760d2,
    meta: {},
    name: "errors-right-required"
  }, {
    path: "/errors/session-expired",
    component: _5a0129bc,
    meta: {},
    name: "errors-session-expired"
  }, {
    path: "/escalade-en/france",
    component: _235d3d2a,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Escalade en France: falaises, topos et salles d'escalade","metaDescription":"Retrouve les informations sur les sites d'escalade en France (voie, grande voie, bloc, via ferrata ...), les topos et les salles d'escalade sur Oblyk"},"en":{"metaTitle":"Climbing in France: crags, guide books and climbing gyms","metaDescription":"Find information on climbing sites in France (routes, multi pitches, boulder, via ferrata ...), guide books and climbing gyms on Oblyk"}}}},
    name: "escalade-en-france"
  }, {
    path: "/find/climbers",
    component: _307abfb6,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Trouver un grimpeur ou une grimpeuse","metaDescription":"Trouver un ou une partenaire de grimpe avec Oblyk"},"en":{"metaTitle":"Find a climber","metaDescription":"Find a climbing partner with Oblyk"}}}},
    name: "find-climbers"
  }, {
    path: "/find/crags",
    component: _5e5383da,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Trouver un site d'escalade","metaDescription":"Trouver le site d'escalade que vous cherchez avec la carte des falaises du monde, ou autour d'une ville ou selon des critères bien particulier grâce à nos outils de recherche."},"en":{"metaTitle":"Find a climbing site","metaDescription":"Find the climbing crag you are looking for with the map of the world's crags, or around a city or according to specific criteria with our search tools."}}}},
    name: "find-crags"
  }, {
    path: "/find/guide-books",
    component: _0b132db5,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Trouver le topo d'escalade que vous cherchez","metaDescription":"Chercher un topo d'escalade autour d'une ville, consulté les dernières nouveauté, fait votre topothèque, etc."},"en":{"metaTitle":"Find the climbing guidebook you are looking for","metaDescription":"Search for a climbing guide book around a city, check the latest news, make your own guidebook library, etc."}}}},
    name: "find-guide-books"
  }, {
    path: "/find/gyms",
    component: _e60e03a8,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Trouver une salle d'escalade","metaDescription":"Trouver une salle d'escalade autour de votre ville grâce à la carte des salle d'escalade ou en recherchant autour d'un lieux"},"en":{"metaTitle":"Find a climbing gym","metaDescription":"Find a climbing gym around your city with the climbing gym map or by searching around a location"}}}},
    name: "find-gyms"
  }, {
    path: "/fr/conditions-d-utilisation",
    component: _84be8928,
    meta: {},
    name: "fr-conditions-d-utilisation"
  }, {
    path: "/fr/cookie-et-mesure-d-audience",
    component: _23e1e2c7,
    meta: {},
    name: "fr-cookie-et-mesure-d-audience"
  }, {
    path: "/guide-book-papers/find",
    component: _708898c0,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Trouver un topo d'escalade","metaDescription":"Trouves les topos d'escalades qu'il y a autour d'une ville ou d'un lieu en France et dans le monde"},"en":{"metaTitle":"Find a climbing guide","metaDescription":"Find the climbing topos that are around a city or a place in France and in the world"}}}},
    name: "guide-book-papers-find"
  }, {
    path: "/guide-book-papers/new",
    component: _a10d72ee,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Ajouter un topo"},"en":{"metaTitle":"Add guide book"}}},"orphanRoute":true},
    name: "guide-book-papers-new"
  }, {
    path: "/guide-book-papers/new-versions",
    component: _e84648e2,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Topos intéressants","metaDescription":"Nous trouvons les topos qui pourrais t'intéresser par rapport à ton carnet de croix"},"en":{"metaTitle":"Interesting guide books","metaDescription":"We find the guide books that might interest you in relation to your log book"}}}},
    name: "guide-book-papers-new-versions"
  }, {
    path: "/guide-book-papers/recommended",
    component: _0f0ac4c4,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Topos intéressants","metaDescription":"Nous trouvons les topos qui pourrais t'intéresser par rapport à ton carnet de croix"},"en":{"metaTitle":"Interesting guide books","metaDescription":"We find the guide books that might interest you in relation to your log book"}}}},
    name: "guide-book-papers-recommended"
  }, {
    path: "/guide-books/features",
    component: _13a8ec65,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Topos d'escalades et fonctionnalités","metaDescription":"Oblyk propose de nombreux outils permettant de trouver les topos, connaître les sites d'escalade qu'ils présentent, avoir une topothèque numérique, etc."},"en":{"metaTitle":"Climbing guides and features","metaDescription":"Oblyk offers many tools for finding guides, knowing the climbing crags they present, having a digital topo library, etc."}}}},
    name: "guide-books-features"
  }, {
    path: "/gyms/new",
    component: _ae2846ca,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Ajouter une nouvelle salle d'escalade"},"en":{"metaTitle":"Add a new climbing gym"}}},"orphanRoute":true},
    name: "gyms-new"
  }, {
    path: "/gyms/starter",
    component: _22e50aec,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Créer le topo de ma salle","metaDescription":"Créer le topo de votre salle d'escalade gratuitement en quelques minutes"},"en":{"metaTitle":"Create a guidebook of my climbing gym","metaDescription":"Create a free climbing gym guidebook in a few minutes"}}}},
    name: "gyms-starter"
  }, {
    path: "/home/climbing-sessions",
    component: _5a029f62,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Mes sessions de grimpe","metaDescription":"La liste de toutes mes sessions de grimpe"},"en":{"metaTitle":"My climbing sessions","metaDescription":"The list of all my climbing sessions"}}}},
    name: "home-climbing-sessions"
  }, {
    path: "/home/community",
    component: _323d66ab,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Ma communauté"},"en":{"metaTitle":"My community"}}}},
    name: "home-community",
    children: [{
      path: "followers",
      component: _05da80b1,
      meta: {"middleware":["auth"],"props":{"user":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Mes abonnées"},"en":{"metaTitle":"My followers"}}}},
      name: "home-community-followers"
    }, {
      path: "subscribes",
      component: _6e3cb67d,
      meta: {"middleware":["auth"],"props":{"user":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Mes abonnées"},"en":{"metaTitle":"My followers"}}}},
      name: "home-community-subscribes"
    }]
  }, {
    path: "/home/favorites",
    component: _1e70ba19,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Mes favorites"},"en":{"metaTitle":"My favorites"}}}},
    name: "home-favorites",
    children: [{
      path: "crags",
      component: _cbbfa570,
      meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Mes falaises"},"en":{"metaTitle":"My crags"}}}},
      name: "home-favorites-crags"
    }, {
      path: "gyms",
      component: _5d5a6efe,
      meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Mes salles"},"en":{"metaTitle":"My gyms"}}}},
      name: "home-favorites-gyms"
    }]
  }, {
    path: "/home/guide-books",
    component: _e25351c4,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Topothèque"},"en":{"metaTitle":"Library"}}}},
    name: "home-guide-books"
  }, {
    path: "/home/media",
    component: _6bb01626,
    meta: {"name":"CurrentUserMediaView","middleware":["auth"],"props":{"user":{"required":true}}},
    name: "home-media",
    children: [{
      path: "photos",
      component: _1b83f68c,
      meta: {"middleware":["auth"],"props":{"user":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Mes photos"},"en":{"metaTitle":"My pictures"}}}},
      name: "home-media-photos"
    }, {
      path: "videos",
      component: _9fde97de,
      meta: {"middleware":["auth"],"props":{"user":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Mes vidéos"},"en":{"metaTitle":"My videos"}}}},
      name: "home-media-videos"
    }]
  }, {
    path: "/home/messenger",
    component: _b51d6656,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Ma messagerie"},"en":{"metaTitle":"My messenger"}}}},
    name: "home-messenger",
    children: [{
      path: "new",
      component: _661afce6,
      meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Nouvelle conversation"},"en":{"metaTitle":"New conversation"}}}},
      name: "home-messenger-new"
    }, {
      path: ":conversationId",
      component: _42368726,
      meta: {"middleware":["auth"],"props":{"user":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Conversation avec %{name}"},"en":{"metaTitle":"Conversation with %{name}"}}}},
      name: "home-messenger-conversationId"
    }]
  }, {
    path: "/home/search-climbers",
    component: _42bc75d8,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Ma recherche de partenaire"},"en":{"metaTitle":"My partner search"}}}},
    name: "home-search-climbers"
  }, {
    path: "/home/settings",
    component: _38b34d14,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Paramètres"},"en":{"metaTitle":"Settings"}}}},
    name: "home-settings"
  }, {
    path: "/indoor/search",
    component: _2391e062,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Chercher une salle","metaDescription":"Chercher et consulter le topo des salles"},"en":{"metaTitle":"Search for climbing gym","metaDescription":"Search and view the guide book of climbing gyms"}}}},
    name: "indoor-search"
  }, {
    path: "/maps/climbers",
    component: _00e32ff2,
    meta: {"name":"PartnerMapView","i18n":{"messages":{"fr":{"metaTitle":"La carte des grimpeur·euse·s d'Oblyk","metaDescription":"La carte des grimpeur·euse·s te permet de trouver un·e partenaire d'escalade près de chez toi. localise toi, trouve un·e grimpeur·euse, contact le·la et allez grimper ensemble !"},"en":{"metaTitle":"Map of Oblyk climbers","metaDescription":"The climber map allows you to find a climbing partner near you. Locate yourself, find a climber, contact him and go climbing together!"}}}},
    name: "maps-climbers"
  }, {
    path: "/maps/crags",
    component: _3fd4d190,
    meta: {"name":"CragMapView","i18n":{"messages":{"fr":{"metaTitle":"Carte des sites d'escalade en France et ailleurs","metaDescription":"Voir la carte interactive des sites naturels de grimpe sur Oblyk, que ce soit en France, ou dans le Monde, et voir leurs informations détaillées"},"en":{"metaTitle":"Map of climbing sites in France and elsewhere","metaDescription":"See the interactive map of natural climbing sites on Oblyk, either in France, or in the World, and see their detailed information"}}}},
    name: "maps-crags"
  }, {
    path: "/maps/guide-book-papers",
    component: _28b64e74,
    meta: {"name":"GymMapView","i18n":{"messages":{"fr":{"metaTitle":"Carte des topos de France et ailleurs","metaDescription":"Voir la carte interactive des topos de grimpe sur Oblyk, que ce soit en France, ou dans le Monde, et voir leurs informations détaillées"},"en":{"metaTitle":"Map of climbing guide books in France and elsewhere","metaDescription":"See the interactive map of climbing guide books on Oblyk, either in France, or in the World, and see their detailed information"}}}},
    name: "maps-guide-book-papers"
  }, {
    path: "/maps/gyms",
    component: _4f18070e,
    meta: {"name":"GymMapView","i18n":{"messages":{"fr":{"metaTitle":"Carte des salle d'escalade en France et ailleurs","metaDescription":"Voir la carte interactive des salle de grimpe sur Oblyk, que ce soit en France, ou dans le Monde, et voir leurs informations détaillées"},"en":{"metaTitle":"Map of climbing gyms in France and elsewhere","metaDescription":"See the interactive map of climbing gyms on Oblyk, either in France, or in the World, and see their detailed information"}}}},
    name: "maps-gyms"
  }, {
    path: "/maps/my-map",
    component: _7865ac9e,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Ma carte"},"en":{"metaTitle":"My map"}}}},
    name: "maps-my-map"
  }, {
    path: "/newsletters/subscribe",
    component: _09086953,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Recevoir la newsletter d'Oblyk","metaDescription":"Abonnez vous à la newsletter d'Oblyk pour recevoir de temps en temps des nouvelles de la communauté grimpante"},"en":{"metaTitle":"Receive the Oblyk newsletter","metaDescription":"Subscribe to the Oblyk newsletter to receive occasional news from the climbing community"}}}},
    name: "newsletters-subscribe"
  }, {
    path: "/newsletters/successful-subscribe",
    component: _235ddc44,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Vous êtes abonnées à la newsletter","metaDescription":"Vous êtes désormais inscrit à notre newsletter, à bientôt dans votre boîte mail"},"en":{"metaTitle":"You are subscribed to the newsletter","metaDescription":"You are now subscribed to our newsletter, see you soon in your mailbox"}}}},
    name: "newsletters-successful-subscribe"
  }, {
    path: "/newsletters/successful-unsubscribe",
    component: _cb991636,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Vous n'êtes plus inscrit à la newsletter","metaDescription":"Vous être désinscrit de la newsletter, à bientôt"},"en":{"metaTitle":"You are no longer subscribed to the newsletter","metaDescription":"You are unsubscribed from the newsletter, see you soon"}}}},
    name: "newsletters-successful-unsubscribe"
  }, {
    path: "/newsletters/unsubscribe",
    component: _371a79cc,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Se désinscrire de la newsletter","metaDescription":"Vous ne voulez plus recevoir notre newsletter, c'est ici que ça se passe"},"en":{"metaTitle":"Unsubscribe from the newsletter","metaDescription":"You don't want to receive our newsletter anymore, this is where it happens"}}}},
    name: "newsletters-unsubscribe"
  }, {
    path: "/organizations/new",
    component: _102942af,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Enregistrer mon organisation"},"en":{"metaTitle":"Register my organization"}}},"orphanRoute":true},
    name: "organizations-new"
  }, {
    path: "/words/new",
    component: _3b01d0b8,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Nouvelle définition"},"en":{"metaTitle":"New definition"}}},"orphanRoute":true},
    name: "words-new"
  }, {
    path: "/ascents/indoor/new",
    component: _5fc6df4c,
    meta: {},
    name: "ascents-indoor-new"
  }, {
    path: "/ascents/outdoor/new",
    component: _d2803f56,
    meta: {"orphanRoute":true},
    name: "ascents-outdoor-new"
  }, {
    path: "/embed/crags/map",
    component: _68ea605a,
    meta: {"layout":"blank"},
    name: "embed-crags-map"
  }, {
    path: "/embed/guide-books/map",
    component: _1b8439a4,
    meta: {"layout":"blank"},
    name: "embed-guide-books-map"
  }, {
    path: "/home/ascents/indoor",
    component: _0191633a,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Mes croix indoor"},"en":{"metaTitle":"My indoor ascents"}}}},
    name: "home-ascents-indoor"
  }, {
    path: "/home/ascents/outdoor",
    component: _2069d0f0,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Mes croix outdoor"},"en":{"metaTitle":"My outdoor ascents"}}}},
    children: [{
      path: "",
      component: _ee0c4fea,
      meta: {"name":"CurrentUserSendListView","props":{"user":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Mes croix outdoor"},"en":{"metaTitle":"My outdoor ascents"}}}},
      name: "home-ascents-outdoor"
    }, {
      path: "analytiks",
      component: _0015dd37,
      meta: {"name":"CurrentUserAnalytiksView","props":{"user":{"required":true}}},
      name: "home-ascents-outdoor-analytiks"
    }, {
      path: "projects",
      component: _32df58d1,
      meta: {"props":{"user":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Mes projets"},"en":{"metaTitle":"My projects"}}}},
      name: "home-ascents-outdoor-projects"
    }, {
      path: "tick-list",
      component: _e59cd8f2,
      meta: {"props":{"user":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Ma tick-list"},"en":{"metaTitle":"My tick-list"}}}},
      name: "home-ascents-outdoor-tick-list"
    }]
  }, {
    path: "/home/guide-books/add",
    component: _06207726,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Ajouter un topo"},"en":{"metaTitle":"Add guide book"}}}},
    name: "home-guide-books-add"
  }, {
    path: "/home/publications/new",
    component: _89e03bf4,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Publier"},"en":{"metaTitle":"Write"}}}},
    name: "home-publications-new"
  }, {
    path: "/home/settings/applications",
    component: _c45493d8,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Modifier mon profil"},"en":{"metaTitle":"Edit my profile"}}}},
    name: "home-settings-applications"
  }, {
    path: "/home/settings/avatar",
    component: _c8736bf2,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Changer mon avatar"},"en":{"metaTitle":"Change my avatar"}}}},
    name: "home-settings-avatar"
  }, {
    path: "/home/settings/banner",
    component: _764fe65a,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Changer mon bandeau"},"en":{"metaTitle":"Change my banner"}}}},
    name: "home-settings-banner"
  }, {
    path: "/home/settings/connection",
    component: _5020820c,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Mes paramètres de connexion"},"en":{"metaTitle":"My connection parameters"}}}},
    name: "home-settings-connection"
  }, {
    path: "/home/settings/general",
    component: _0751a0ac,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Modifier mon profil"},"en":{"metaTitle":"Edit my profile"}}}},
    name: "home-settings-general"
  }, {
    path: "/home/settings/notifications",
    component: _75d6742a,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Mes paramètres de notification"},"en":{"metaTitle":"My notification parameters"}}}},
    name: "home-settings-notifications"
  }, {
    path: "/home/settings/others",
    component: _ac0651de,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Autre paramètres"},"en":{"metaTitle":"Other parameters"}}}},
    name: "home-settings-others"
  }, {
    path: "/home/settings/partner",
    component: _020e138a,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Ma présence sur la carte des grimpeurs"},"en":{"metaTitle":"My presence on the climbers' map"}}}},
    name: "home-settings-partner"
  }, {
    path: "/home/settings/privacy",
    component: _2190fa4a,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Mes paramètres de confidentialité"},"en":{"metaTitle":"My privacy parameters"}}}},
    name: "home-settings-privacy"
  }, {
    path: "/outdoor/search/crag-routes",
    component: _0184c0c0,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Chercher une voie, un bloc, une via ferrata","metaDescription":"Chercher une voie, un bloc, une via ferrata dans la base d'Oblyk"},"en":{"metaTitle":"Search for a route, a boulder, a via ferrata","metaDescription":"Search for a route, a boulder, or a via ferrata in the Oblyk database."}}}},
    name: "outdoor-search-crag-routes"
  }, {
    path: "/outdoor/search/crags",
    component: _43620a3c,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Chercher une falaise, une topo, une voie","metaDescription":"Chercher une falaise, une topo, une voie sur dans la base de donnée d'Oblyk"},"en":{"metaTitle":"Search for a crag, a climbing guidebook, a route","metaDescription":"Search for a crag, a climbing guidebook, or a route in the Oblyk database."}}}},
    name: "outdoor-search-crags"
  }, {
    path: "/outdoor/search/guide-books",
    component: _30c7e297,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Chercher un topo d'escalade","metaDescription":"Chercher un topo d'escalade dans la base de donnée d'Oblyk"},"en":{"metaTitle":"Search for a climbing guidebook","metaDescription":"Search for a climbing guide in the Oblyk database"}}}},
    name: "outdoor-search-guide-books"
  }, {
    path: "/home/settings/applications/new/my-compet",
    component: _1cebb1d2,
    meta: {"middleware":["auth"]},
    name: "home-settings-applications-new-my-compet"
  }, {
    path: "/",
    component: _1a33ab50,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Oblyk - Escalade, Carnet de croix & Carte des grimpeur·euse·s","metaDescription":"Oblyk est un site communautaire d'escalade outdoor et indoor, on peut : voir les informations des falaises, noter ses croix, trouver un partenaire d'escalade, etc."},"en":{"metaTitle":"Oblyk - Climbing community, Log book & Partner search","metaDescription":"Oblyk is an outdoor and indoor climbing community site, you can: see crag information, keep a logbook, find a climbing partner, etc."}}}},
    name: "index"
  }, {
    path: "/embed/publications/:publicationId",
    component: _4c5fcd0a,
    meta: {"layout":"blank"},
    name: "embed-publications-publicationId"
  }, {
    path: "/home/climbing-sessions/:sessionDate",
    component: _1b763c88,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Ma session de grimpe du %{date}","metaDescription":"Les croix, lieux, grimpeurs et grimpeuses avec qui j'ai grimpé le %{date}"},"en":{"metaTitle":"My climbing session on %{date}","metaDescription":"My ascents, places, climbers with whom I climbed on %{date}"}}}},
    name: "home-climbing-sessions-sessionDate"
  }, {
    path: "/home/publications/:publicationId?/edit",
    component: _1f6af937,
    meta: {"scrollToTop":true,"i18n":{"messages":{"fr":{"metaTitle":"Éditer la publication"},"en":{"metaTitle":"Edit publication"}}}},
    name: "home-publications-publicationId-edit"
  }, {
    path: "/escalade-en/france/:departmentNumber?/:departementName",
    component: _01cabf0a,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Escalade %{name} : falaises, topos et salles d'escalade","metaDescription":"Retrouve les informations sur les sites d'escalade %{name} (voie, grande voie, bloc, via ferrata ...), les topos et les salles d'escalade sur Oblyk"},"en":{"metaTitle":"Climbing %{name} : crags, guide book and climbing gyms","metaDescription":"Find information on climbing sites %{name} (routes, multi pitches, boulder, via ferrata ...), guide books and climbing gyms on Oblyk"}}}},
    name: "escalade-en-france-departmentNumber-departementName"
  }, {
    path: "/climbers/:userName?",
    component: _127d4849,
    meta: {},
    children: [{
      path: "",
      component: _6adab40c,
      meta: {"name":"UserProfileView","scrollToTop":true,"props":{"user":{"required":true}}},
      name: "climbers-userName"
    }, {
      path: "ascents",
      component: _0f2dbe13,
      meta: {"scrollToTop":true,"props":{"user":{"required":true}}},
      name: "climbers-userName-ascents",
      children: [{
        path: "indoor",
        component: _343b5cff,
        meta: {"props":{"user":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Les croix outdoor de %{name}","metaDescription":"Consulter les croix outdoor faites par %{name} tout au long de sa vie de grimpeur·euse"},"en":{"metaTitle":"The outdoor ascents of %{name}","metaDescription":"Consult the outdoor ascents made by %{name} throughout his climbing life"}}}},
        name: "climbers-userName-ascents-indoor"
      }, {
        path: "outdoor",
        component: _4aa78d80,
        meta: {"props":{"user":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Les croix outdoor de %{name}","metaDescription":"Consulter les croix outdoor faites par %{name} tout au long de sa vie de grimpeur·euse"},"en":{"metaTitle":"The outdoor ascents of %{name}","metaDescription":"Consult the outdoor ascents made by %{name} throughout his climbing life"}}}},
        name: "climbers-userName-ascents-outdoor"
      }]
    }, {
      path: "followers",
      component: _6cc91662,
      meta: {"scrollToTop":true,"props":{"user":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Les abonnés de %{name}","metaDescription":"Voir les grimpeur·euse·s abonnées à %{name}, grimpeur·euse de la communauté Oblyk"},"en":{"metaTitle":"The subscribers of %{name}","metaDescription":"See the climbers subscribed to %{name}, climber of the community Oblyk"}}}},
      name: "climbers-userName-followers"
    }, {
      path: "media",
      component: _1a91221e,
      meta: {"scrollToTop":true,"props":{"user":{"required":true}}},
      name: "climbers-userName-media",
      children: [{
        path: "photos",
        component: _434e11c2,
        meta: {"props":{"user":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Photos de %{name}","metaDescription":"Voir les photos d'escalade prise par %{name} sur les différentes falaises qu'iel a parcourut"},"en":{"metaTitle":"Photos of %{name}","metaDescription":"See the climbing pictures taken by %{name} on the different cliffs he climbed"}}}},
        name: "climbers-userName-media-photos"
      }, {
        path: "videos",
        component: _0120c119,
        meta: {"props":{"user":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Videos de %{name}","metaDescription":"Voir les vidéos d'escalade prise par %{name} sur les différentes falaises qu'iel a parcourut"},"en":{"metaTitle":"Videos of %{name}","metaDescription":"See the climbing videos taken by %{name} on the different cliffs he climbed"}}}},
        name: "climbers-userName-media-videos"
      }]
    }, {
      path: "publications",
      component: _32f5cefd,
      meta: {"scrollToTop":true,"props":{"user":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Les publications et actualités de %{name}","metaDescription":"Les publications et actualités de %{name}"},"en":{"metaTitle":"%{name}'s publications and news","metaDescription":"%{name}'s publications and news"}}}},
      name: "climbers-userName-publications"
    }, {
      path: "subscribes",
      component: _229a461f,
      meta: {"scrollToTop":true,"props":{"user":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Abonnement de %{name}","metaDescription":"Voir les abonnements aux falaises, salles, et autre grimpeur·euse de %{name}"},"en":{"metaTitle":"Subscribe of %{name}","metaDescription":"View memberships to cliffs, gyms, and other climbers in %{name}"}}}},
      name: "climbers-userName-subscribes"
    }]
  }, {
    path: "/comments/:commentId",
    component: _7357d252,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Commentaire"},"en":{"metaTitle":"Comment"}}}},
    name: "comments-commentId"
  }, {
    path: "/escalade-autour-de/:townName",
    component: _713403ce,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Escalade %{name} : falaises, topos et salles d'escalade","metaDescription":"Retrouve les informations sur les sites d'escalade autour de %{name} (%{department_number}) : voie, grande voie, bloc, via ferrata ..., les topos et les salles d'escalade sur Oblyk"},"en":{"metaTitle":"Climbing %{name} : crags, guide book and climbing gyms","metaDescription":"Find information on climbing sites around %{name} (%{department_number}) : routes, multi pitches, boulder, via ferrata ..., guide books and climbing gyms on Oblyk"}}}},
    name: "escalade-autour-de-townName"
  }, {
    path: "/gr/:gymAndRouteId",
    component: _b689c524,
    meta: {},
    name: "gr-gymAndRouteId"
  }, {
    path: "/grs/:gymId",
    component: _8f5b999a,
    meta: {},
    name: "grs-gymId"
  }, {
    path: "/gym-chains/:gymChainId?",
    component: _dd5b20b2,
    meta: {},
    children: [{
      path: "",
      component: _35805cea,
      meta: {"props":{"gymChain":{"required":true}}},
      name: "gym-chains-gymChainId"
    }]
  }, {
    path: "/photos/:photoId",
    component: _a2e28706,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Photo"},"en":{"metaTitle":"Photo"}}}},
    name: "photos-photoId"
  }, {
    path: "/publications/:publicationId",
    component: _5d660e9e,
    meta: {},
    name: "publications-publicationId"
  }, {
    path: "/videos/:videoId",
    component: _5edb450f,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Vidéo"},"en":{"metaTitle":"Video"}}}},
    name: "videos-videoId"
  }, {
    path: "/alerts/:alertId?/edit",
    component: _f6274b4a,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Modifier l'alerte"},"en":{"metaTitle":"Edit alert"}}},"orphanRoute":true},
    name: "alerts-alertId-edit"
  }, {
    path: "/authors/:authorId?/cover",
    component: _533e55c4,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Ajouter une couverture à l'auteur"},"en":{"metaTitle":"Add author cover"}}},"orphanRoute":true},
    name: "authors-authorId-cover"
  }, {
    path: "/authors/:authorId?/edit",
    component: _7d3353e6,
    meta: {"middleware":["auth"],"orphanRoute":true},
    name: "authors-authorId-edit"
  }, {
    path: "/comments/:commentId?/edit",
    component: _bda354d6,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Modifier le commentaire"},"en":{"metaTitle":"Edit comment"}}},"orphanRoute":true},
    name: "comments-commentId-edit"
  }, {
    path: "/guide-book-pdfs/:guideBookPdfId?/edit",
    component: _40fae55f,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Modifier le topo PDF"},"en":{"metaTitle":"Edit PDF guide"}}},"orphanRoute":true},
    name: "guide-book-pdfs-guideBookPdfId-edit"
  }, {
    path: "/guide-book-webs/:guideBookWebId?/edit",
    component: _6a83dd9f,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Modifier le topo web"},"en":{"metaTitle":"Edit web guide"}}},"orphanRoute":true},
    name: "guide-book-webs-guideBookWebId-edit"
  }, {
    path: "/links/:linkId?/edit",
    component: _0074b3ed,
    meta: {"middleware":["auth"],"orphanRoute":true},
    name: "links-linkId-edit"
  }, {
    path: "/areas/:areaId?/:areaName?",
    component: _00f40464,
    meta: {},
    children: [{
      path: "",
      component: _5ec6a032,
      meta: {"scrollToTop":true,"props":{"area":{"required":true}}},
      name: "areas-areaId-areaName"
    }, {
      path: "crags",
      component: _5af75353,
      meta: {"scrollToTop":true,"props":{"area":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Les falaises de %{name}, Groupe de sites d'escalade","metaDescription":"Voir les falaises du groupe de sites d'escalade de %{name}, quels spots de grimpe il présente ou encore quelle variété de cotations on y trouve"},"en":{"metaTitle":"Crags of %{name}, climbing crags group","metaDescription":"See the crags of the group of climbing sites of %{name}, what kind of climbing spots it offers or what variety of grades can be found there"}}}},
      name: "areas-areaId-areaName-crags"
    }, {
      path: "photos",
      component: _08499688,
      meta: {"scrollToTop":true,"props":{"area":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Les photos de %{name}, Groupe de sites d'escalade","metaDescription":"Voir les photos du groupe de sites d'escalade de %{name}, quels spots de grimpe il présente ou encore quelle variété de cotations on y trouve"},"en":{"metaTitle":"Pictures of %{name}, climbing crags group","metaDescription":"See the pictures of the group of climbing sites of %{name}, what kind of climbing spots it offers or what variety of grades can be found there"}}}},
      name: "areas-areaId-areaName-photos"
    }]
  }, {
    path: "/articles/:articleId/:articleName",
    component: _72bdd382,
    meta: {},
    name: "articles-articleId-articleName"
  }, {
    path: "/crag-routes/:cragRouteId?/:cragRouteName",
    component: _0ff1e653,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"%{name} %{grade}, %{cragName}","metaDescription":"%{name} %{grade}, %{type} faisant partie du site d'escalade %{cragName}. voir le detail de la ligne : cotation, photo, avis, etc."},"en":{"metaTitle":"%{name} %{grade}, %{cragName}","metaDescription":"%{name} %{grade}, %{type} forming part of the climbing site %{cragName}. see the details of the line: grade, photo, opinion, etc."}}}},
    name: "crag-routes-cragRouteId-cragRouteName"
  }, {
    path: "/crag-sectors/:cragSectorId?/:cragSectorName?",
    component: _74e49ffa,
    meta: {},
    children: [{
      path: "",
      component: _b9ee2f74,
      meta: {"scrollToTop":true,"props":{"cragSector":{"required":true}}},
      name: "crag-sectors-cragSectorId-cragSectorName"
    }, {
      path: "maps",
      component: _2da6b75a,
      meta: {"name":"CragSectorMapView","scrollToTop":true,"props":{"cragSector":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"La carte de %{name}, secteur d'escalade de %{crag}","metaDescription":"La carte de  %{name}, secteur d'escalade %{crag} situé à %{city} en %{region}."},"en":{"metaTitle":"Map of %{name}, climbing sector of %{crag}","metaDescription":"Map of %{name}, climbing sector of %{crag} located at %{city} in %{region}"}}}},
      name: "crag-sectors-cragSectorId-cragSectorName-maps"
    }, {
      path: "photos",
      component: _76f6083d,
      meta: {"name":"CragSectorPhotosView","scrollToTop":true,"props":{"cragSector":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Les photos de %{name}, secteur d'escalade de %{crag}","metaDescription":"Les photos de  %{name}, secteur d'escalade %{crag} situé à %{city} en %{region}."},"en":{"metaTitle":"Pictures of %{name}, climbing sector of %{crag}","metaDescription":"Pictures of %{name}, climbing sector of %{crag} located at %{city} in %{region}"}}}},
      name: "crag-sectors-cragSectorId-cragSectorName-photos"
    }]
  }, {
    path: "/crags/:cragId?/:cragName?",
    component: _b8a478a8,
    meta: {},
    children: [{
      path: "",
      component: _6b8bd92f,
      meta: {"scrollToTop":true,"props":{"crag":{"required":true}}},
      name: "crags-cragId-cragName"
    }, {
      path: "guide-books",
      component: _181ed1b6,
      meta: {"name":"CragGuideBooksView","scrollToTop":true,"props":{"crag":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Les topos de %{name}, escalade en %{region}","metaDescription":"Les topos de %{name} : site d'escalade à %{city} en %{region}"},"en":{"metaTitle":"Climbing guide book of %{name}, climb in %{region}","metaDescription":"Climbing guide book of %{name} : climbing crag in %{city} in %{region}"}}}},
      name: "crags-cragId-cragName-guide-books"
    }, {
      path: "links",
      component: _3be83496,
      meta: {"name":"CragLinkView","scrollToTop":true,"props":{"crag":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Les liens de %{name}, escalade en %{region}","metaDescription":"Les liens de %{name} : site d'escalade à %{city} en %{region}"},"en":{"metaTitle":"Links of %{name}, climb in %{region}","metaDescription":"Links of %{name} : climbing crag in %{city} in %{region}"}}}},
      name: "crags-cragId-cragName-links"
    }, {
      path: "maps",
      component: _61ff994d,
      meta: {"name":"CragMapDetailsView","scrollToTop":true,"props":{"crag":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"La carte de %{name}, escalade en %{region}","metaDescription":"La carte de %{name} : site d'escalade à %{city} en %{region}"},"en":{"metaTitle":"Map of %{name}, climb in %{region}","metaDescription":"Map of %{name} : climbing crag in %{city} in %{region}"}}}},
      name: "crags-cragId-cragName-maps"
    }, {
      path: "photos",
      component: _825d9718,
      meta: {"name":"CragPhotosView","scrollToTop":true,"props":{"crag":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Les photos de %{name}, escalade en %{region}","metaDescription":"Les photos de %{name} : site d'escalade à %{city} en %{region}"},"en":{"metaTitle":"Pictures of %{name}, climb in %{region}","metaDescription":"Pictures of %{name} : climbing crag in %{city} in %{region}"}}}},
      name: "crags-cragId-cragName-photos"
    }, {
      path: "publications",
      component: _5c9def7d,
      meta: {"scrollToTop":true,"props":{"crag":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Les dernières informations de %{name}, escalade en %{region}","metaDescription":"Le panneau d'infos, retrouver les dernières actualité de %{name} : site d'escalade à %{city} en %{region}"},"en":{"metaTitle":"The latest news from %{name}, climb in %{region}","metaDescription":"The information board, find the latest news about %{name} : climbing crag in %{city} in %{region}"}}}},
      name: "crags-cragId-cragName-publications"
    }, {
      path: "routes",
      component: _b6c10900,
      meta: {"scrollToTop":true,"props":{"crag":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Les voies de %{name}, site d'escalade en %{region}","metaDescription":"Retrouvez toutes les voies et blocs du site d'escalade de %{name}, les cotations et les avis des grimpeurs"},"en":{"metaTitle":"The routes of %{name}, climbing site in %{region}","metaDescription":"Find all the routes and boulders of the %{name} climbing site, the quotations and the climbers' opinions"}}}},
      name: "crags-cragId-cragName-routes"
    }, {
      path: "publications/new",
      component: _66bcfbea,
      meta: {"props":{"crag":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Publier"},"en":{"metaTitle":"Write"}}}},
      name: "crags-cragId-cragName-publications-new"
    }, {
      path: "publications/:publicationId/edit",
      component: _a5e42188,
      meta: {"scrollToTop":true,"props":{"crag":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Éditer la publication"},"en":{"metaTitle":"Edit publication"}}}},
      name: "crags-cragId-cragName-publications-publicationId-edit"
    }]
  }, {
    path: "/guide-book-papers/:guideBookPaperId?/:guideBookPaperName?",
    component: _002f10cc,
    meta: {},
    children: [{
      path: "",
      component: _7fe6ce4f,
      meta: {"props":{"guideBookPaper":{"required":true}}},
      name: "guide-book-papers-guideBookPaperId-guideBookPaperName"
    }, {
      path: "alternatives",
      component: _9eac130e,
      meta: {"scrollToTop":true,"props":{"guideBookPaper":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Topos alternatifs à %{name}","metaDescription":"Liste des autres topos d'escalades qui traitent des mêmes sites que le topo %{name}"},"en":{"metaTitle":"Alternative guides to %{name}","metaDescription":"List of other climbing guidebooks that deal with the same crags as the guidebook %{name}"}}}},
      name: "guide-book-papers-guideBookPaperId-guideBookPaperName-alternatives"
    }, {
      path: "crags",
      component: _0a4171bb,
      meta: {"name":"GuideBookPaperCragsView","scrollToTop":true,"props":{"guideBookPaper":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Les falaises de %{name}, topo d'escalade","metaDescription":"Voir les falaises du topo d'escalade %{name}."},"en":{"metaTitle":"Crags of %{name}, climbing guide book","metaDescription":"See the crags of %{name} climbing guide book"}}}},
      name: "guide-book-papers-guideBookPaperId-guideBookPaperName-crags"
    }, {
      path: "links",
      component: _504329b6,
      meta: {"name":"GuideBookPaperLinkView","scrollToTop":true,"props":{"guideBookPaper":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Les liens de %{name}, topo d'escalade","metaDescription":"Voir les liens du topo d'escalade %{name}."},"en":{"metaTitle":"Links of %{name}, climbing guide book","metaDescription":"See the links of %{name} climbing guide book"}}}},
      name: "guide-book-papers-guideBookPaperId-guideBookPaperName-links"
    }, {
      path: "map",
      component: _b088a9ce,
      meta: {"name":"GuideBookPaperMapView","scrollToTop":true,"props":{"guideBookPaper":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"La carte de %{name}, topo d'escalade","metaDescription":"Voir la carte du topo d'escalade %{name}."},"en":{"metaTitle":"Map of %{name}, climbing guide book","metaDescription":"See the map of %{name} climbing guide book"}}}},
      name: "guide-book-papers-guideBookPaperId-guideBookPaperName-map"
    }, {
      path: "photos",
      component: _35d4e354,
      meta: {"name":"GuideBookPaperPhotosView","scrollToTop":true,"props":{"guideBookPaper":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Les photos de %{name}, topo d'escalade","metaDescription":"Voir les photos du topo d'escalade %{name}."},"en":{"metaTitle":"Pictures of %{name}, climbing guide book","metaDescription":"See the pictures of %{name} climbing guide book"}}}},
      name: "guide-book-papers-guideBookPaperId-guideBookPaperName-photos"
    }, {
      path: "points-of-sale",
      component: _4a3d2666,
      meta: {"scrollToTop":true,"props":{"guideBookPaper":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Les points de vente de %{name}, topo d'escalade","metaDescription":"Voir les points de vente du topo d'escalade %{name}."},"en":{"metaTitle":"Points of sale of %{name}, climbing guide book","metaDescription":"See the Points of sale of %{name} climbing guide book"}}}},
      name: "guide-book-papers-guideBookPaperId-guideBookPaperName-points-of-sale"
    }, {
      path: "publications",
      component: _28324e5d,
      meta: {"scrollToTop":true,"props":{"guideBookPaper":{"required":true}}},
      name: "guide-book-papers-guideBookPaperId-guideBookPaperName-publications"
    }, {
      path: "publications/new",
      component: _558018eb,
      meta: {"middleware":["auth"],"scrollToTop":true,"props":{"guideBookPaper":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Publier"},"en":{"metaTitle":"Write"}}}},
      name: "guide-book-papers-guideBookPaperId-guideBookPaperName-publications-new"
    }, {
      path: "publications/:publicationId/edit",
      component: _52ba73c8,
      meta: {"middleware":["auth"],"scrollToTop":true,"props":{"guideBookPaper":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Éditer la publication"},"en":{"metaTitle":"Edit publication"}}}},
      name: "guide-book-papers-guideBookPaperId-guideBookPaperName-publications-publicationId-edit"
    }]
  }, {
    path: "/gyms/:gymId?/:gymName?",
    component: _15ddd70c,
    meta: {},
    children: [{
      path: "",
      component: _6a76d77d,
      meta: {"scrollToTop":true,"props":{"gym":{"required":true}}},
      name: "gyms-gymId-gymName"
    }, {
      path: "followers",
      component: _e2b31080,
      meta: {"scrollToTop":true,"props":{"gym":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Les abonnés de %{name}","metaDescription":"Voir les grimpeurs et grimpeuses abonné·es à la salle d'escalade %{name}"},"en":{"metaTitle":"The subscribers of %{name}","metaDescription":"See the climbers subscribed to %{name} climbing gym"}}}},
      name: "gyms-gymId-gymName-followers"
    }, {
      path: "publications",
      component: _49931fef,
      meta: {"scrollToTop":true,"props":{"gym":{"required":true}}},
      name: "gyms-gymId-gymName-publications"
    }, {
      path: "ranking",
      component: _09273021,
      meta: {"props":{"gym":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Le classement de %{name}","metaDescription":"Voir le classement des grimpeurs et grimpeuses de la salle d'escalade %{name}"},"en":{"metaTitle":"%{name}'s ranking","metaDescription":"See the ranking of climbers in the climbing gym %{name}"}}}},
      name: "gyms-gymId-gymName-ranking"
    }, {
      path: "spaces",
      component: _8a06fad6,
      meta: {"scrollToTop":true,"props":{"gym":{"required":true}}},
      name: "gyms-gymId-gymName-spaces"
    }, {
      path: "publications/new",
      component: _5ca7b206,
      meta: {"middleware":["auth","gymAdmin"],"scrollToTop":true,"props":{"gym":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Publier"},"en":{"metaTitle":"Write"}}}},
      name: "gyms-gymId-gymName-publications-new"
    }, {
      path: "publications/:publicationId/edit",
      component: _70e4702e,
      meta: {"middleware":["auth","gymAdmin"],"scrollToTop":true,"props":{"gym":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Éditer la publication"},"en":{"metaTitle":"Edit publication"}}}},
      name: "gyms-gymId-gymName-publications-publicationId-edit"
    }, {
      path: "spaces/:gymSpaceId/:gymSpaceName",
      component: _6e7bd871,
      meta: {"scrollToTop":true,"props":{"gym":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"%{name} topo indoor de la salle d'escalade %{gym}","metaDescription":"Consulter le détail des voies d'escalade de %{gym}, ajoutez vos croix pour suivre votre progression"},"en":{"metaTitle":"%{name} indoor guide book of climbing gym %{gym}","metaDescription":"Consult the details of the climbing routes of %{gym}, add your ascents to track your progress"}}}},
      name: "gyms-gymId-gymName-spaces-gymSpaceId-gymSpaceName"
    }]
  }, {
    path: "/organizations/:organizationId?/:organizationName?",
    component: _3a10644a,
    meta: {},
    children: [{
      path: "",
      component: _88e1e966,
      meta: {"props":{"organization":{"required":true}}},
      name: "organizations-organizationId-organizationName"
    }]
  }, {
    path: "/words/:wordId?/:slugName",
    component: _f886c236,
    meta: {},
    name: "words-wordId-slugName"
  }, {
    path: "/alerts/:alertableType?/:alertableId?/new",
    component: _7161830a,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Créer une alerte"},"en":{"metaTitle":"Create alert"}}},"orphanRoute":true},
    name: "alerts-alertableType-alertableId-new"
  }, {
    path: "/articles/:articleId/:articleName?/add-crags",
    component: _3ff2f0c2,
    meta: {"orphanRoute":true},
    name: "articles-articleId-articleName-add-crags"
  }, {
    path: "/articles/:articleId/:articleName?/add-guide-books",
    component: _0b174c9d,
    meta: {"orphanRoute":true},
    name: "articles-articleId-articleName-add-guide-books"
  }, {
    path: "/articles/:articleId/:articleName?/cover",
    component: _18e003e7,
    meta: {"orphanRoute":true},
    name: "articles-articleId-articleName-cover"
  }, {
    path: "/articles/:articleId/:articleName?/edit",
    component: _0194d78a,
    meta: {"orphanRoute":true},
    name: "articles-articleId-articleName-edit"
  }, {
    path: "/articles/:articleId/:articleName?/photos",
    component: _c442f6fe,
    meta: {},
    name: "articles-articleId-articleName-photos"
  }, {
    path: "/comments/:commentableType?/:commentableId?/new",
    component: _b1bb6f90,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Ajouter un commentaire"},"en":{"metaTitle":"Add comment"}}},"orphanRoute":true},
    name: "comments-commentableType-commentableId-new"
  }, {
    path: "/contests/:gymId/:contestId?/print-results",
    component: _76ed0e1e,
    meta: {"layout":"blank"},
    name: "contests-gymId-contestId-print-results"
  }, {
    path: "/links/:linkableType?/:linkableId?/new",
    component: _7c8d9165,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Ajouter un nouveau lien"},"en":{"metaTitle":"Add a new link"}}},"orphanRoute":true},
    name: "links-linkableType-linkableId-new"
  }, {
    path: "/photos/:illustrableType?/:illustrableId?/new",
    component: _6669f905,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Ajouter une photo"},"en":{"metaTitle":"Add a photo"}}}},
    name: "photos-illustrableType-illustrableId-new"
  }, {
    path: "/reports/:reportableType?/:reportableId?/new",
    component: _c5d7dc42,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Signaler un problème","metaDescription":"Vous avez trouvé un problème? dit le nous pour qu'on le corrige"},"en":{"metaTitle":"Report a problem","metaDescription":"Have you found a problem? Tell us so we can fix it"}}}},
    name: "reports-reportableType-reportableId-new"
  }, {
    path: "/versions/:versionType?/:versionId?/changes",
    component: _1b6db03c,
    meta: {"name":"VersionsView"},
    name: "versions-versionType-versionId-changes"
  }, {
    path: "/videos/:viewableType?/:viewableId?/new",
    component: _da1ea664,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Ajouter une video"},"en":{"metaTitle":"Add a video"}}},"orphanRoute":true},
    name: "videos-viewableType-viewableId-new"
  }, {
    path: "/words/:wordId?/:slugName?/edit",
    component: _33ad93c7,
    meta: {"middleware":["auth"],"orphanRoute":true},
    name: "words-wordId-slugName-edit"
  }, {
    path: "/contests/:gymId/:contestId?/:contestJudgeUuid",
    component: _660f62bb,
    meta: {"layout":"blank"},
    name: "contests-gymId-contestId-contestJudgeUuid"
  }, {
    path: "/photos/:illustrableType?/:illustrableId?/:photoId?/edit",
    component: _4ebcd770,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Modifier la photo"},"en":{"metaTitle":"Edit photo"}}}},
    name: "photos-illustrableType-illustrableId-photoId-edit"
  }, {
    path: "/videos/:viewableType?/:viewableId?/:videoId?/edit",
    component: _5d3c93e0,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Modifier la video"},"en":{"metaTitle":"Edit video"}}}},
    name: "videos-viewableType-viewableId-videoId-edit"
  }, {
    path: "/gym-chains/:gymChainId?/banner",
    component: _1324d144,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Changer le bandeau"},"en":{"metaTitle":"Edit banner"}}},"orphanRoute":true},
    name: "gym-chains-gymChainId-banner"
  }, {
    path: "/gym-chains/:gymChainId?/edit",
    component: _31278122,
    meta: {"middleware":["auth"],"orphanRoute":true},
    name: "gym-chains-gymChainId-edit"
  }, {
    path: "/gym-chains/:gymChainId?/logo",
    component: _4a842043,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Changer le logo"},"en":{"metaTitle":"Edit logo"}}},"orphanRoute":true},
    name: "gym-chains-gymChainId-logo"
  }, {
    path: "/areas/:areaId?/:areaName?/add-crag",
    component: _4f624dfc,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Ajouter un site à %{name}"},"en":{"metaTitle":"Add crag in %{name}"}}},"orphanRoute":true},
    name: "areas-areaId-areaName-add-crag"
  }, {
    path: "/areas/:areaId?/:areaName?/edit",
    component: _2de65a85,
    meta: {"orphanRoute":true},
    name: "areas-areaId-areaName-edit"
  }, {
    path: "/crags/:cragId?/:cragName?/add-on-area",
    component: _8fd0f6a8,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Ajouter %{name} à une zone"},"en":{"metaTitle":"Add %{name} in area"}}},"orphanRoute":true},
    name: "crags-cragId-cragName-add-on-area"
  }, {
    path: "/crags/:cragId?/:cragName?/add-on-guide-book",
    component: _d996390e,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Ajouter un topo à %{name}"},"en":{"metaTitle":"Add paper guide at %{name}"}}},"orphanRoute":true},
    name: "crags-cragId-cragName-add-on-guide-book"
  }, {
    path: "/crags/:cragId?/:cragName?/edit",
    component: _816e2f86,
    meta: {"middleware":["auth"],"orphanRoute":true},
    name: "crags-cragId-cragName-edit"
  }, {
    path: "/crags/:cragId?/:cragName?/new-pdf-guide-book",
    component: _489d0195,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Ajouter un topo PDF"},"en":{"metaTitle":"Add PDF guide"}}},"orphanRoute":true},
    name: "crags-cragId-cragName-new-pdf-guide-book"
  }, {
    path: "/crags/:cragId?/:cragName?/new-web-guide-book",
    component: _72fc96f3,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Ajouter un topo web"},"en":{"metaTitle":"Add web guide"}}},"orphanRoute":true},
    name: "crags-cragId-cragName-new-web-guide-book"
  }, {
    path: "/crags/:cragId?/:cragName?/approaches/new",
    component: _b115f74c,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Créer une approche"},"en":{"metaTitle":"Create approach"}}},"orphanRoute":true},
    name: "crags-cragId-cragName-approaches-new"
  }, {
    path: "/crags/:cragId?/:cragName?/maps/edit",
    component: _e524a742,
    meta: {"middleware":["auth"],"orphanRoute":true},
    name: "crags-cragId-cragName-maps-edit"
  }, {
    path: "/crags/:cragId?/:cragName?/parks/new",
    component: _6377d637,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Ajouter un parking"},"en":{"metaTitle":"Add a park"}}},"orphanRoute":true},
    name: "crags-cragId-cragName-parks-new"
  }, {
    path: "/crags/:cragId?/:cragName?/routes/new",
    component: _648c32ce,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Ajouter une ligne"},"en":{"metaTitle":"Add crag route"}}},"orphanRoute":true},
    name: "crags-cragId-cragName-routes-new"
  }, {
    path: "/crags/:cragId?/:cragName?/sectors/new",
    component: _5ea310fb,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Ajouter un secteur"},"en":{"metaTitle":"Add sector"}}},"orphanRoute":true},
    name: "crags-cragId-cragName-sectors-new"
  }, {
    path: "/crags/:cragId?/:cragName?/approaches/:approachId?/edit",
    component: _0e4a81ad,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Modifier l'approche"},"en":{"metaTitle":"Edit approach"}}},"orphanRoute":true},
    name: "crags-cragId-cragName-approaches-approachId-edit"
  }, {
    path: "/crags/:cragId?/:cragName?/parks/:parkId?/edit",
    component: _7dbb5324,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Modifier le parking"},"en":{"metaTitle":"Edit park"}}},"orphanRoute":true},
    name: "crags-cragId-cragName-parks-parkId-edit"
  }, {
    path: "/crags/:cragId?/:cragName?/routes/:cragRouteId/:cragRouteName?/edit",
    component: _387578bc,
    meta: {"middleware":["auth"],"orphanRoute":true},
    name: "crags-cragId-cragName-routes-cragRouteId-cragRouteName-edit"
  }, {
    path: "/crags/:cragId?/:cragName?/sectors/:cragSectorId?/:cragSectorName?/edit",
    component: _42ddf143,
    meta: {"middleware":["auth"],"orphanRoute":true},
    name: "crags-cragId-cragName-sectors-cragSectorId-cragSectorName-edit"
  }, {
    path: "/crags/:cragId?/:cragName?/routes/:cragRouteId/:cragRouteName?/ascents/new",
    component: _d23a5eb0,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Ajouter à mon carnet"},"en":{"metaTitle":"Add to my logbook"}}},"orphanRoute":true},
    name: "crags-cragId-cragName-routes-cragRouteId-cragRouteName-ascents-new"
  }, {
    path: "/crags/:cragId?/:cragName?/sectors/:cragSectorId?/:cragSectorName?/routes/new",
    component: _79dbdf54,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Ajouter une ligne"},"en":{"metaTitle":"Add crag route"}}},"orphanRoute":true},
    name: "crags-cragId-cragName-sectors-cragSectorId-cragSectorName-routes-new"
  }, {
    path: "/crags/:cragId?/:cragName?/routes/:cragRouteId/:cragRouteName?/ascents/:ascentCragRouteId?/edit",
    component: _36d259ea,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Modifier ma croix"},"en":{"metaTitle":"Edit my ascent"}}},"orphanRoute":true},
    name: "crags-cragId-cragName-routes-cragRouteId-cragRouteName-ascents-ascentCragRouteId-edit"
  }, {
    path: "/guide-book-papers/:guideBookPaperId?/:guideBookPaperName?/add-crag",
    component: _1caa92d8,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Ajouter un site à %{name}"},"en":{"metaTitle":"Add crag in %{name}"}}},"orphanRoute":true},
    name: "guide-book-papers-guideBookPaperId-guideBookPaperName-add-crag"
  }, {
    path: "/guide-book-papers/:guideBookPaperId?/:guideBookPaperName?/cover",
    component: _2608feb4,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Changer la couverture de %{name}"},"en":{"metaTitle":"Change cover of %{name}"}}},"orphanRoute":true},
    name: "guide-book-papers-guideBookPaperId-guideBookPaperName-cover"
  }, {
    path: "/guide-book-papers/:guideBookPaperId?/:guideBookPaperName?/edit",
    component: _b1aa61c6,
    meta: {"middleware":["auth"],"orphanRoute":true},
    name: "guide-book-papers-guideBookPaperId-guideBookPaperName-edit"
  }, {
    path: "/guide-book-papers/:guideBookPaperId?/:guideBookPaperName?/place-of-sales/new",
    component: _108b4d00,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Ajouter un point de vente"},"en":{"metaTitle":"Add a place of sale"}}},"orphanRoute":true},
    name: "guide-book-papers-guideBookPaperId-guideBookPaperName-place-of-sales-new"
  }, {
    path: "/guide-book-papers/:guideBookPaperId?/:guideBookPaperName?/place-of-sales/:placeOfSaleId?/edit",
    component: _0bfa4bd0,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Modifier le point de vente"},"en":{"metaTitle":"Edit place of sale"}}},"orphanRoute":true},
    name: "guide-book-papers-guideBookPaperId-guideBookPaperName-place-of-sales-placeOfSaleId-edit"
  }, {
    path: "/gyms/:gymId?/:gymName?/administration-request",
    component: _25156e05,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Demande d'administration de %{name}","metaDescription":"Administrez la salle d'escalade de %{name} pour créer votre topo indoor et animer votre communauté"},"en":{"metaTitle":"Request for administration of %{name}","metaDescription":"Manage the %{name} climbing gym to create your indoor topo and animate your community"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-administration-request"
  }, {
    path: "/gyms/:gymId?/:gymName?/administrator-required",
    component: _56b3c104,
    meta: {"props":{"gym":{"required":true}},"i18n":{"messages":{"fr":{"metaTitle":"Administrateur requis"},"en":{"metaTitle":"Required administrator"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-administrator-required"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins",
    component: _1b2858ac,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"%{name} - Dashboard"},"en":{"metaTitle":"%{name} - Dashboard"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins"
  }, {
    path: "/gyms/:gymId?/:gymName?/banner",
    component: _7cfda911,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Changer le bandeau"},"en":{"metaTitle":"Edit banner"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-banner"
  }, {
    path: "/gyms/:gymId?/:gymName?/edit",
    component: _92042fa2,
    meta: {"middleware":["auth"],"orphanRoute":true},
    name: "gyms-gymId-gymName-edit"
  }, {
    path: "/gyms/:gymId?/:gymName?/logo",
    component: _5f4af160,
    meta: {"middleware":["auth"],"i18n":{"messages":{"fr":{"metaTitle":"Changer le logo"},"en":{"metaTitle":"Edit logo"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-logo"
  }, {
    path: "/gyms/:gymId?/:gymName?/select-space",
    component: _0451bc9a,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Choisissez un espace"},"en":{"metaTitle":"Choose a space"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-select-space"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/administrators",
    component: _01c6dc5f,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"Les administrateurs"},"en":{"metaTitle":"Administrators"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-administrators"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/championships",
    component: _5e50734b,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"Les championnats"},"en":{"metaTitle":"Championships"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-championships"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/climbing-styles",
    component: _7475087f,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"Style d'escalade"},"en":{"metaTitle":"Climbing styles"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-climbing-styles"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/comments",
    component: _9e88cfe6,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"Les commentaires"},"en":{"metaTitle":"Comments"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-comments"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/contests",
    component: _a0470390,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"Les contests"},"en":{"metaTitle":"Contests"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-contests"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/first-difficulty-system",
    component: _15a2bcfe,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"Premier système de difficulté"},"en":{"metaTitle":"First difficulty system"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-first-difficulty-system"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/first-space",
    component: _c9c472fa,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"Créer le premier espace de %{name}","metaDescription":"commencez à créer votre topo d'escalade indoor en créant le première espace de %{name}"},"en":{"metaTitle":"Create the first space for %{name}","metaDescription":"Start creating your indoor climbing map by creating the first %{name} space"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-first-space"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/indoor-subscriptions",
    component: _3e3e6fd6,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Mes abonnements"},"en":{"metaTitle":"My subscriptions"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-indoor-subscriptions"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/label-templates",
    component: _f4b15606,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"Modèle d'étiquettes"},"en":{"metaTitle":"Label templates"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-label-templates"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/levels",
    component: _2dc79948,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"Couleurs et cotations"},"en":{"metaTitle":"Colors and grades"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-levels"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/openers",
    component: _b2dbc18e,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"Les ouvreurs"},"en":{"metaTitle":"Openers"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-openers"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/opening-sheets",
    component: _100e5e62,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"Les fiches d'ouvertures"},"en":{"metaTitle":"Opening sheets"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-opening-sheets"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/ranking-systems",
    component: _71270aac,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"System de classement"},"en":{"metaTitle":"Ranking system"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-ranking-systems"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/tree-structures",
    component: _73d319c9,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"La structure"},"en":{"metaTitle":"Structure"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-tree-structures"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/videos",
    component: _cb36a01e,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"Les vidéos"},"en":{"metaTitle":"Videos"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-videos"
  }, {
    path: "/gyms/:gymId?/:gymName?/spaces/new",
    component: _6f39fb23,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Créer un nouvel espace"},"en":{"metaTitle":"Create a new space"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-spaces-new"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/administrators/new",
    component: _c0f78126,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"Ajouter un administrateur"},"en":{"metaTitle":"Add administrator"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-administrators-new"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/championships/new",
    component: _0dc2bd4e,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"Créer un championnat"},"en":{"metaTitle":"Create championship"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-championships-new"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/contests/new",
    component: _cbcaf8f4,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"Créer un contest"},"en":{"metaTitle":"Create contest"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-contests-new"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/label-templates/new",
    component: _2bc6478b,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"Créer un modèle d'étiquette"},"en":{"metaTitle":"Create label template"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-label-templates-new"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/openers/new",
    component: _201670c7,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"Ajouter un ouvreur"},"en":{"metaTitle":"Add opener"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-openers-new"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/opening-sheets/new",
    component: _ba8b33a0,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"Créer une fiche d'ouverture"},"en":{"metaTitle":"Create opening sheet"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-opening-sheets-new"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/routes/cross-statistics",
    component: _20ba5ecf,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"%{name} - Tableau croisé"},"en":{"metaTitle":"%{name} - Cross statistics"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-routes-cross-statistics"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/routes/statistics",
    component: _2bb82ae2,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"%{name} - Statistique"},"en":{"metaTitle":"%{name} - Statistic"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-routes-statistics"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/routes/tables",
    component: _18deb2a4,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"%{name} - Gestion des ouvertures"},"en":{"metaTitle":"%{name} - Routes management"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-routes-tables"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/space-groups/new",
    component: _060a0b22,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"Créer un group"},"en":{"metaTitle":"Create group"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-space-groups-new"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/spaces/edit-three-d",
    component: _1f2c992e,
    meta: {"middleware":["auth","gymAdmin"],"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-spaces-edit-three-d"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/three-d-assets/new",
    component: _032910fc,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"Importer une décoration"},"en":{"metaTitle":"Import asset"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-three-d-assets-new"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/championships/:championshipId",
    component: _3bd82a10,
    meta: {"middleware":["auth","gymAdmin"],"orphanRoute":true},
    children: [{
      path: "",
      component: _e65b510a,
      meta: {"middleware":["auth","gymAdmin"],"props":{"championship":{"required":true}},"orphanRoute":true},
      name: "gyms-gymId-gymName-admins-championships-championshipId"
    }, {
      path: "results",
      component: _7183385f,
      meta: {"middleware":["auth","gymAdmin"],"props":{"championship":{"required":true}},"orphanRoute":true},
      name: "gyms-gymId-gymName-admins-championships-championshipId-results"
    }]
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/contests/:contestId",
    component: _2d07635a,
    meta: {"middleware":["auth","gymAdmin"],"orphanRoute":true},
    children: [{
      path: "",
      component: _7d230346,
      meta: {"middleware":["auth","gymAdmin"],"props":{"contest":{"required":true}},"orphanRoute":true},
      name: "gyms-gymId-gymName-admins-contests-contestId"
    }, {
      path: "banner",
      component: _04fade31,
      meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"Illustration du contest"},"en":{"metaTitle":"Contest picture"}}},"orphanRoute":true},
      name: "gyms-gymId-gymName-admins-contests-contestId-banner"
    }, {
      path: "edit",
      component: _bdf43562,
      meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"Créer un contest"},"en":{"metaTitle":"Create contest"}}},"orphanRoute":true},
      name: "gyms-gymId-gymName-admins-contests-contestId-edit"
    }, {
      path: "judges",
      component: _88d4697e,
      meta: {"middleware":["auth","gymAdmin"],"props":{"contest":{"required":true}}},
      name: "gyms-gymId-gymName-admins-contests-contestId-judges"
    }, {
      path: "participants",
      component: _3dfc9236,
      meta: {"middleware":["auth","gymAdmin"],"props":{"contest":{"required":true}}},
      name: "gyms-gymId-gymName-admins-contests-contestId-participants"
    }, {
      path: "results",
      component: _209da27e,
      meta: {"middleware":["auth","gymAdmin"],"props":{"contest":{"required":true}}},
      name: "gyms-gymId-gymName-admins-contests-contestId-results"
    }, {
      path: "statistics",
      component: _016d83b0,
      meta: {"middleware":["auth","gymAdmin"],"props":{"contest":{"required":true}}},
      name: "gyms-gymId-gymName-admins-contests-contestId-statistics"
    }, {
      path: "teams",
      component: _2fbb657e,
      meta: {"middleware":["auth","gymAdmin"],"props":{"contest":{"required":true}}},
      name: "gyms-gymId-gymName-admins-contests-contestId-teams"
    }, {
      path: "time-line",
      component: _bd7d0c02,
      meta: {"middleware":["auth","gymAdmin"],"props":{"contest":{"required":true},"editContestModal":{"default":null}},"orphanRoute":true},
      name: "gyms-gymId-gymName-admins-contests-contestId-time-line"
    }]
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/label-templates/:gymLabelTemplateId",
    component: _6553d2ca,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"Étiquette : %{name}"},"en":{"metaTitle":"Label : %{name}"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-label-templates-gymLabelTemplateId"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/opening-sheets/:gymOpeningSheetId",
    component: _14c6b121,
    meta: {"middleware":["auth","gymAdmin"],"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-opening-sheets-gymOpeningSheetId"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/administrators/:gymAdministratorId/edit",
    component: _38728210,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"Modifier le system de cotation"},"en":{"metaTitle":"Edit grade system"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-administrators-gymAdministratorId-edit"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/label-templates/:gymLabelTemplateId?/print",
    component: _db478a14,
    meta: {"layout":"print","orphanRoute":true},
    name: "gyms-gymId-gymName-admins-label-templates-gymLabelTemplateId-print"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/openers/:gymOpenerId/edit",
    component: _f923fc5c,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"Modifier %{name}"},"en":{"metaTitle":"Edit %{name}"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-openers-gymOpenerId-edit"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/opening-sheets/:gymOpeningSheetId?/print",
    component: _4c665508,
    meta: {"layout":"print","orphanRoute":true},
    name: "gyms-gymId-gymName-admins-opening-sheets-gymOpeningSheetId-print"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/space-groups/:gymSpaceGroupId?/edit",
    component: _bf441fea,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"Modifier %{name}"},"en":{"metaTitle":"Edit %{name}"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-space-groups-gymSpaceGroupId-edit"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/spaces/:gymSpaceId?/edit-three-d",
    component: _18b43fd8,
    meta: {"middleware":["auth","gymAdmin"],"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-spaces-gymSpaceId-edit-three-d"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/spaces/:gymSpaceId?/take-three-d-picture",
    component: _31c26586,
    meta: {"middleware":["auth","gymAdmin"],"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-spaces-gymSpaceId-take-three-d-picture"
  }, {
    path: "/gyms/:gymId?/:gymName?/admins/three-d-assets/:threeDAssetId?/edit",
    component: _4a5f9c16,
    meta: {"middleware":["auth","gymAdmin"],"i18n":{"messages":{"fr":{"metaTitle":"Éditer la décoration"},"en":{"metaTitle":"Edit asset"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-admins-three-d-assets-threeDAssetId-edit"
  }, {
    path: "/gyms/:gymId?/:gymName?/contests/rankers/:contestId?/:contestName",
    component: _45616942,
    meta: {"layout":"contest","channels":{"ContestRankersChannel":{}},"orphanRoute":true},
    name: "gyms-gymId-gymName-contests-rankers-contestId-contestName"
  }, {
    path: "/gyms/:gymId?/:gymName?/championships/:championshipId?/:championshipName",
    component: _4695fcac,
    meta: {"layout":"contest","orphanRoute":true},
    name: "gyms-gymId-gymName-championships-championshipId-championshipName"
  }, {
    path: "/gyms/:gymId?/:gymName?/contests/:contestId?/:contestName?",
    component: _51d42dd4,
    meta: {"layout":"contest","orphanRoute":true},
    children: [{
      path: "",
      component: _0497f552,
      meta: {"layout":"contest","props":{"contest":{"required":true},"updateToken":{"required":true}},"orphanRoute":true},
      name: "gyms-gymId-gymName-contests-contestId-contestName"
    }, {
      path: "my-contest",
      component: _005f243e,
      meta: {"props":{"contest":{"required":true}}},
      name: "gyms-gymId-gymName-contests-contestId-contestName-my-contest"
    }, {
      path: "results",
      component: _30b0df3b,
      meta: {"props":{"contest":{"required":true}}},
      name: "gyms-gymId-gymName-contests-contestId-contestName-results"
    }]
  }, {
    path: "/gyms/:gymId?/:gymName?/spaces/:gymSpaceId/:gymSpaceName?/edit",
    component: _b2ca0e8a,
    meta: {"orphanRoute":true},
    name: "gyms-gymId-gymName-spaces-gymSpaceId-gymSpaceName-edit"
  }, {
    path: "/gyms/:gymId?/:gymName?/spaces/:gymSpaceId/:gymSpaceName?/select-sector",
    component: _0eee2776,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Choisissez un secteur"},"en":{"metaTitle":"Choose a sector"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-spaces-gymSpaceId-gymSpaceName-select-sector"
  }, {
    path: "/gyms/:gymId?/:gymName?/spaces/:gymSpaceId/:gymSpaceName?/upload-3d",
    component: _23af2c7c,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Modifier le 3D"},"en":{"metaTitle":"Modify the 3D"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-spaces-gymSpaceId-gymSpaceName-upload-3d"
  }, {
    path: "/gyms/:gymId?/:gymName?/spaces/:gymSpaceId/:gymSpaceName?/upload-plan",
    component: _9a340758,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Modifier le plan de fond"},"en":{"metaTitle":"Modify the background schema"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-spaces-gymSpaceId-gymSpaceName-upload-plan"
  }, {
    path: "/gyms/:gymId?/:gymName?/spaces/:gymSpaceId/:gymSpaceName?/sectors/new",
    component: _2ab316bd,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Ajouter un secteur"},"en":{"metaTitle":"Add a sector"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-spaces-gymSpaceId-gymSpaceName-sectors-new"
  }, {
    path: "/gyms/:gymId?/:gymName?/spaces/:gymSpaceId/:gymSpaceName?/routes/:gymRouteId?/edit",
    component: _3fa10915,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Modifier la ligne"},"en":{"metaTitle":"Edit route"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-spaces-gymSpaceId-gymSpaceName-routes-gymRouteId-edit"
  }, {
    path: "/gyms/:gymId?/:gymName?/spaces/:gymSpaceId/:gymSpaceName?/routes/:gymRouteId?/picture",
    component: _2ad2eb7a,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Définir une photo"},"en":{"metaTitle":"Define the picture"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-spaces-gymSpaceId-gymSpaceName-routes-gymRouteId-picture"
  }, {
    path: "/gyms/:gymId?/:gymName?/spaces/:gymSpaceId/:gymSpaceName?/routes/:gymRouteId?/thumbnail",
    component: _0b591ff1,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Définir une miniature"},"en":{"metaTitle":"Define thumbnail"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-spaces-gymSpaceId-gymSpaceName-routes-gymRouteId-thumbnail"
  }, {
    path: "/gyms/:gymId?/:gymName?/spaces/:gymSpaceId/:gymSpaceName?/sectors/:gymSectorId?/add-to-publication",
    component: _256a8735,
    meta: {"orphanRoute":true},
    name: "gyms-gymId-gymName-spaces-gymSpaceId-gymSpaceName-sectors-gymSectorId-add-to-publication"
  }, {
    path: "/gyms/:gymId?/:gymName?/spaces/:gymSpaceId/:gymSpaceName?/sectors/:gymSectorId?/edit",
    component: _0b5b16f9,
    meta: {"orphanRoute":true},
    name: "gyms-gymId-gymName-spaces-gymSpaceId-gymSpaceName-sectors-gymSectorId-edit"
  }, {
    path: "/gyms/:gymId?/:gymName?/spaces/:gymSpaceId/:gymSpaceName?/sectors/:gymSectorId?/routes/new",
    component: _12d7648a,
    meta: {"i18n":{"messages":{"fr":{"metaTitle":"Ajouter une ligne"},"en":{"metaTitle":"Add a new route"}}},"orphanRoute":true},
    name: "gyms-gymId-gymName-spaces-gymSpaceId-gymSpaceName-sectors-gymSectorId-routes-new"
  }, {
    path: "/organizations/:organizationId?/:organizationName?/edit",
    component: _29b00b42,
    meta: {"middleware":["auth"],"orphanRoute":true},
    name: "organizations-organizationId-organizationName-edit"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
